function setHeaderHeightCssVariable() {
  const header = document.querySelector('sticky-header, .header__wrapper');

  if (!header) return;

  document.documentElement.style.setProperty('--header-height', `${header.offsetHeight}px`);
}

setHeaderHeightCssVariable();
window.addEventListener('load', setHeaderHeightCssVariable);
window.addEventListener('resize', setHeaderHeightCssVariable);

const PRODUCT_REVIEWS_HASH = '#product-reviews';
const SCROLL_TO_REVIEWS_KEY = 'backflip-scroll-to-reviews';
let pendingReviewsScrollStarted = false;

function normalizePath(path) {
  const normalized = (path || '/').replace(/\/+$/, '');
  return normalized || '/';
}

function getProductPath(productUrl) {
  if (!productUrl) return '';

  try {
    return normalizePath(new URL(productUrl, window.location.origin).pathname);
  } catch (err) {
    return normalizePath(productUrl.split(/[?#]/)[0]);
  }
}

function isCurrentProductPage(productUrl) {
  const productPath = getProductPath(productUrl);
  if (!productPath) return false;

  return normalizePath(window.location.pathname) === productPath;
}

function getProductReviewsSection() {
  const anchor = document.getElementById('product-reviews');

  if (anchor) {
    return anchor.closest('.section-apps[data-section-id], .section-apps') || anchor;
  }

  const bvReviews = document.querySelector('[data-bv-show="reviews"]');
  if (bvReviews) {
    return bvReviews.closest('.section-apps[data-section-id], .section-apps, .shopify-block') || bvReviews;
  }

  return document.querySelector(
    '.junip-review-section, .junip-product-review, [class*="junip-review-section"], [id*="junip"][id*="review"]'
  );
}

function getScrollBehavior() {
  return window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
}

function scrollToProductReviews() {
  const reviewSection = getProductReviewsSection();
  if (!reviewSection) return false;

  reviewSection.scrollIntoView({
    behavior: getScrollBehavior(),
    block: 'start',
  });

  return true;
}

function getProductReviewsWrapper() {
  return document.querySelector('[data-product-reviews-scroll][data-product-url]');
}

function handleProductReviewsActivation(wrapper) {
  const productUrl = wrapper?.dataset.productUrl;

  if (productUrl && !isCurrentProductPage(productUrl)) {
    navigateToProductReviews(productUrl);
    return true;
  }

  return scrollToProductReviews();
}

function activateProductReviewsScroll() {
  const wrapper = getProductReviewsWrapper();

  if (wrapper) {
    return handleProductReviewsActivation(wrapper);
  }

  return scrollToProductReviews();
}

function clearReviewsHash() {
  if (window.location.hash !== PRODUCT_REVIEWS_HASH) return;

  history.replaceState(null, '', `${window.location.pathname}${window.location.search}`);
}

function shouldScrollToReviewsOnLoad() {
  return (
    sessionStorage.getItem(SCROLL_TO_REVIEWS_KEY) === '1' ||
    window.location.hash === PRODUCT_REVIEWS_HASH
  );
}

function handlePendingReviewsScroll() {
  if (pendingReviewsScrollStarted || !shouldScrollToReviewsOnLoad()) return;

  pendingReviewsScrollStarted = true;
  sessionStorage.removeItem(SCROLL_TO_REVIEWS_KEY);
  clearReviewsHash();

  const tryActivate = () => activateProductReviewsScroll();

  const runAfterLoad = () => {
    setHeaderHeightCssVariable();

    if (tryActivate()) return;

    window.setTimeout(tryActivate, 500);
  };

  if (document.readyState === 'complete') {
    runAfterLoad();
    return;
  }

  window.addEventListener('load', runAfterLoad, { once: true });
}

function navigateToProductReviews(productUrl) {
  if (!productUrl) return;

  const baseUrl = productUrl.split('#')[0].split('?')[0];
  sessionStorage.setItem(SCROLL_TO_REVIEWS_KEY, '1');
  window.location.href = baseUrl;
}

function isBvInlineReady(widget) {
  if (!widget) return false;

  const stars = widget.querySelector('.bv_stars_svg_no_wrap svg, .bv_stars_component_container svg');
  const count = widget.querySelector('.bv_numReviews_component_container .bv_text');
  return Boolean(stars && count && /\d/.test(count.textContent || ''));
}

function restyleBvInlineCount(widget) {
  if (!widget) return;

  const isBundleCard = Boolean(widget.closest('.bundle-product-card'));
  const isProductCard = Boolean(widget.closest('.product-card'));
  const starSize = isBundleCard ? '11px' : '16px';

  widget.querySelectorAll('.bv_numReviews_component_container .bv_text').forEach((node) => {
    const digits = node.textContent.replace(/[()]/g, '').replace(/\s*reviews?/i, '').trim();
    const next = /^\d+$/.test(digits) ? `${digits} Reviews` : '';

    if (next && node.textContent !== next) {
      node.textContent = next;
    }
  });

  if (widget.dataset.bfBvInlineStyled === 'true') return;
  widget.dataset.bfBvInlineStyled = 'true';

  widget.querySelectorAll('.bv_stars_svg_no_wrap svg').forEach((svg) => {
    svg.style.setProperty('width', starSize, 'important');
    svg.style.setProperty('height', starSize, 'important');
  });

  widget.querySelectorAll('.bv_numReviews_component_container, .bv_numReviews_component_container .bv_text').forEach((node) => {
    const isCountText = node.classList.contains('bv_text');

    node.style.setProperty('margin', '0', 'important');
    node.style.setProperty('display', 'inline-flex', 'important');
    node.style.setProperty('align-items', 'center', 'important');

    if (isBundleCard && isCountText) {
      node.style.setProperty('height', 'auto', 'important');
      node.style.setProperty('line-height', '1', 'important');
      node.style.setProperty('overflow', 'visible', 'important');
      node.style.setProperty('padding', '0px 0px 0px', 'important');
      node.style.setProperty('transform', 'none', 'important');
      node.style.setProperty('font-size', '11px', 'important');
      node.style.setProperty('color', '#231f20', 'important');
      return;
    }

    node.style.setProperty('height', isBundleCard && !isCountText ? '13px' : starSize, 'important');
    node.style.setProperty('line-height', starSize, 'important');
    node.style.setProperty('padding', '0', 'important');
    node.style.setProperty('overflow', isBundleCard ? 'visible' : 'hidden', 'important');

    if (isBundleCard) {
      node.style.setProperty('font-size', '11px', 'important');
      node.style.setProperty('color', '#231f20', 'important');
    }

    if (isProductCard) {
      node.style.setProperty('color', '#231f20', 'important');
    }
  });
}

function revealBvReviewDisplay(wrapper) {
  wrapper.classList.add('product-reviews--revealed');
}

function armBvReviewRevealFallback(wrapper) {
  if (wrapper.dataset.bfBvRevealArmed === 'true') return;
  wrapper.dataset.bfBvRevealArmed = 'true';

  window.setTimeout(() => {
    if (!wrapper.isConnected || wrapper.classList.contains('product-reviews--has-data')) return;
    revealBvReviewDisplay(wrapper);
  }, 4000);
}

function syncBvReviewDisplay(root = document) {
  root.querySelectorAll('.product-reviews--bv, [class*="__reviews--bv"]').forEach((wrapper) => {
    const widget = wrapper.querySelector('[data-bv-show="inline_rating"]');
    const fallback = wrapper.querySelector('.product-reviews__fallback');
    const hasBvData = isBvInlineReady(widget);

    wrapper.classList.toggle('product-reviews--has-data', hasBvData);

    if (fallback) {
      fallback.hidden = hasBvData;
    }

    if (hasBvData) {
      restyleBvInlineCount(widget);
      revealBvReviewDisplay(wrapper);
    } else {
      armBvReviewRevealFallback(wrapper);
    }
  });
}

function initProductReviewsScroll() {
  document.querySelectorAll('[data-product-reviews-scroll]').forEach((wrapper) => {
    if (wrapper.dataset.reviewsScrollBound === 'true') return;
    if (!wrapper.dataset.productUrl) return;

    wrapper.dataset.reviewsScrollBound = 'true';
    wrapper.classList.add('product-reviews--scrollable');

    wrapper.addEventListener('click', (event) => {
      if (event.target.closest('a, button, [role="button"], [role="link"]')) return;

      event.preventDefault();
      handleProductReviewsActivation(wrapper);
    });
  });
}

const BV_SHADOW_STYLE_ID = 'bf-bv-shadow-styles';
const BV_FONT_BODY = 'var(--font-body--family, "Arial Rounded MT Bold", sans-serif)';
const BV_FONT_HEADING = 'var(--font-heading--family, Fania, sans-serif)';
const BV_YELLOW = 'var(--color-yellow, #fbcf29)';
const BV_INK = 'var(--color-black, #231f20)';
const BV_SHADOW_CSS = `
  :host,
  * {
    font-family: ${BV_FONT_BODY} !important;
    box-shadow: none !important;
    text-shadow: none !important;
  }

  h1,
  h2,
  h4,
  h5,
  h6,
  h1 *,
  h2 *,
  h4 *,
  h5 *,
  h6 * {
    font-family: ${BV_FONT_HEADING} !important;
    font-weight: 100 !important;
    letter-spacing: -0.03em;
  }

  h3,
  h3 *,
  h3[class],
  h3[class] * {
    font-family: "Arial Rounded MT Bold", sans-serif !important;
    font-weight: 400 !important;
    letter-spacing: 0 !important;
  }

  p,
  span,
  li,
  label,
  button,
  input,
  textarea,
  a {
    font-family: ${BV_FONT_BODY} !important;
    font-weight: 400 !important;
  }

  input:not([type="checkbox"]):not([type="radio"]):not([type="hidden"]):not([type="file"]):not([role="combobox"]),
  textarea,
  #search-input {
    background: #fff !important;
    border: 2px solid ${BV_INK} !important;
    border-radius: 6px !important;
    box-shadow: none !important;
    box-sizing: border-box !important;
    caret-color: ${BV_INK} !important;
    color: ${BV_INK} !important;
    font-size: 14px !important;
    line-height: 1.2 !important;
    padding: 8px 12px !important;
  }

  input:not([type="checkbox"]):not([type="radio"]):not([type="hidden"]):not([type="file"]):not([role="combobox"]),
  #search-input {
    height: 42px !important;
    min-height: 42px !important;
  }

  /* Native IPS radios/checkboxes stay clipped. The visible checkbox is the
     sibling [role="checkbox"] widget (terms). Radios are option containers
     that include labels — never shrink those to an 18px glyph. */
  [class*="ips_"] input[type="checkbox"],
  [class*="ips_"] input[type="radio"] {
    clip: rect(0, 0, 0, 0) !important;
    height: 1px !important;
    margin: -1px !important;
    opacity: 0 !important;
    overflow: hidden !important;
    padding: 0 !important;
    pointer-events: none !important;
    position: absolute !important;
    width: 1px !important;
  }

  [class*="ips_"] [role="checkbox"] {
    align-items: center !important;
    align-self: center !important;
    background: #fff !important;
    border: 2px solid ${BV_INK} !important;
    border-radius: 3px !important;
    box-sizing: border-box !important;
    cursor: pointer !important;
    display: inline-flex !important;
    flex-shrink: 0 !important;
    height: 18px !important;
    justify-content: center !important;
    margin: 0 8px 0 0 !important;
    min-height: 18px !important;
    min-width: 18px !important;
    opacity: 1 !important;
    padding: 0 !important;
    pointer-events: auto !important;
    position: relative !important;
    visibility: visible !important;
    width: 18px !important;
  }

  [class*="ips_"] [role="checkbox"] svg {
    display: block !important;
    height: 12px !important;
    overflow: visible !important;
    width: 12px !important;
  }

  [class*="ips_"] [role="checkbox"] svg * {
    fill: none !important;
    stroke: ${BV_INK} !important;
    stroke-width: 2 !important;
  }

  [class*="ips_"] [role="checkbox"][aria-checked="false"] svg {
    opacity: 0 !important;
  }

  [class*="ips_"] [role="radiogroup"] {
    align-items: flex-start !important;
    display: flex !important;
    flex-wrap: wrap !important;
    gap: 8px 12px !important;
    justify-content: flex-start !important;
    overflow: visible !important;
    width: 100% !important;
  }

  [class*="ips_"] [role="radiogroup"] > * {
    align-items: center !important;
    display: flex !important;
    flex: 1 1 3.5rem !important;
    flex-direction: column !important;
    justify-content: flex-start !important;
    min-width: 3.5rem !important;
    overflow: visible !important;
    position: relative !important;
    width: auto !important;
  }

  [class*="ips_"] [role="radiogroup"] > * > span,
  [class*="ips_"] [role="radiogroup"] > * > label {
    overflow: visible !important;
    position: static !important;
    text-align: center !important;
    white-space: normal !important;
    width: 100% !important;
  }

  [class*="ips_"] [role="radio"] {
    align-items: center !important;
    background: transparent !important;
    border: 0 !important;
    box-sizing: border-box !important;
    cursor: pointer !important;
    display: inline-flex !important;
    flex: 0 1 auto !important;
    height: auto !important;
    justify-content: center !important;
    margin: 0 !important;
    max-width: none !important;
    min-height: 0 !important;
    min-width: 2.75rem !important;
    opacity: 1 !important;
    overflow: visible !important;
    padding: 4px 8px !important;
    pointer-events: auto !important;
    position: relative !important;
    visibility: visible !important;
    white-space: normal !important;
    width: auto !important;
  }

  [class*="ips_"] [role="radio"]:not([aria-label*="star" i]):not([id^="bv-ips-star"]) {
    background: #fff !important;
    border: 2px solid ${BV_INK} !important;
    border-radius: 6px !important;
    padding: 6px 12px !important;
  }

  [class*="ips_"] [role="radio"][aria-checked="true"]:not([aria-label*="star" i]):not([id^="bv-ips-star"]) {
    background: ${BV_YELLOW} !important;
  }

  [class*="ips_"] [role="radio"][id^="bv-ips-star"] {
    background: transparent !important;
    border: 0 !important;
    padding: 4px !important;
  }

  [class*="ips_"] [role="radio"][id^="bv-ips-star"][aria-checked="true"] svg path {
    fill: ${BV_YELLOW} !important;
  }

  [class*="ips_"] [role="radio"] svg {
    display: block !important;
    flex-shrink: 0 !important;
    height: auto !important;
    max-height: 40px !important;
    max-width: 40px !important;
    overflow: visible !important;
    width: auto !important;
  }

  [class*="ips_"] [role="radio"]:not([aria-label*="star" i]):not([id^="bv-ips-star"]) svg {
    height: 18px !important;
    width: 18px !important;
  }

  [class*="ips_"] [role="radio"] span,
  [class*="ips_"] [role="radio"] p,
  [class*="ips_"] [role="radio"] label {
    height: auto !important;
    line-height: 1.2 !important;
    overflow: visible !important;
    position: static !important;
    text-overflow: unset !important;
    white-space: normal !important;
    width: auto !important;
  }

  [class*="ips_"] #bv-ips-submit,
  [class*="ips_"] button[id*="submit" i] {
    height: auto !important;
    line-height: 1.2 !important;
    max-width: 100% !important;
    min-height: 42px !important;
    overflow: visible !important;
    text-overflow: unset !important;
    white-space: normal !important;
  }

  [class*="ips_"] #bv-ips-submit span,
  [class*="ips_"] button[id*="submit" i] span {
    overflow: visible !important;
    text-overflow: unset !important;
    white-space: normal !important;
  }

  [class*="ips_"] div:has(> #bv-ips-submit) {
    align-items: stretch !important;
    display: flex !important;
    flex-wrap: wrap !important;
    gap: 8px !important;
    overflow: visible !important;
  }

  [class*="ips_"] [id^="agreement"],
  [class*="ips_"] div:has(> label > [role="checkbox"]),
  [class*="ips_"] label:has(> [role="checkbox"]),
  [class*="ips_"] label:has(> input[type="checkbox"]) {
    align-items: flex-start !important;
    display: flex !important;
    flex-direction: row !important;
    flex-wrap: nowrap !important;
    height: auto !important;
    line-height: 1.35 !important;
    min-height: 18px !important;
  }

  [class*="ips_"] [id^="agreement"] > label,
  [class*="ips_"] label:has(> [role="checkbox"]) {
    align-self: flex-start !important;
    flex-shrink: 0 !important;
    height: 18px !important;
    margin: 2px 8px 0 0 !important;
  }

  [class*="ips_"] [id^="agreement"] > span,
  [class*="ips_"] label:has(> [role="checkbox"]) + span {
    display: inline !important;
    flex: 1 1 auto !important;
    height: auto !important;
    line-height: 1.35 !important;
    margin: 0 !important;
    overflow: visible !important;
    padding: 0 !important;
    white-space: normal !important;
  }

  [class*="ips_"] [id^="agreement"] .bv-text-link,
  [class*="ips_"] [id^="agreement"] [role="button"] {
    color: inherit !important;
    cursor: pointer !important;
    display: inline !important;
    font-size: inherit !important;
    height: auto !important;
    line-height: inherit !important;
    text-decoration: underline !important;
    width: auto !important;
  }

  #search-input,
  input[aria-label^="Search"] {
    background-image: none !important;
    max-width: none !important;
    padding-right: 40px !important;
    width: 100% !important;
  }

  /* Glass lives on the wrap, not the input — so it cannot stack with the clear X. */
  [role="search"]:has(> #search-input:placeholder-shown):not(:has(> button))::after,
  div:has(> #search-input:placeholder-shown):not(:has(> button))::after {
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' stroke='%23231f20' stroke-width='2' viewBox='0 0 16 16'%3E%3Ccircle cx='7' cy='7' r='5'/%3E%3Cpath d='M11 11l3 3'/%3E%3C/svg%3E");
    background-position: center !important;
    background-repeat: no-repeat !important;
    background-size: 16px !important;
    content: '' !important;
    height: 16px !important;
    pointer-events: none !important;
    position: absolute !important;
    right: 14px !important;
    top: 13px !important;
    width: 16px !important;
    z-index: 1 !important;
  }

  textarea {
    height: auto !important;
    max-width: none !important;
    min-height: 6.5rem !important;
    resize: vertical;
  }

  input::placeholder,
  textarea::placeholder,
  #search-input::placeholder {
    color: #6b6b6b !important;
    font-size: 14px !important;
    opacity: 1;
  }

  #bv-dropdown-select-reviews,
  [data-bf-bv-sort-cluster] > select,
  select[id*="bv-dropdown"],
  select[id*="dropdown-select"] {
    -webkit-appearance: none !important;
    appearance: none !important;
    background: transparent !important;
    background-image: none !important;
    border: 0 !important;
    clip: rect(0, 0, 0, 0) !important;
    height: 0 !important;
    margin: 0 !important;
    min-height: 0 !important;
    opacity: 0 !important;
    overflow: hidden !important;
    padding: 0 !important;
    pointer-events: none !important;
    position: absolute !important;
    width: 0 !important;
  }

  [aria-label^="Menu, Filter"][role="combobox"],
  [aria-label^="Menu, Sort"][role="combobox"],
  [aria-label*="Filter" i][role="combobox"],
  [aria-label*="Sort" i][role="combobox"] {
    -webkit-appearance: none !important;
    appearance: none !important;
    align-items: center !important;
    background: transparent !important;
    border: 0 !important;
    border-radius: 0 !important;
    box-shadow: none !important;
    box-sizing: border-box !important;
    color: #fff !important;
    display: inline-flex !important;
    gap: 6px;
    height: auto !important;
    margin: 0 16px 0 0 !important;
    max-width: 100%;
    min-height: 0 !important;
    min-width: 0 !important;
    padding: 0 !important;
    position: relative !important;
    transform: none !important;
    width: max-content !important;
  }

  [aria-label^="Menu, Filter"][role="combobox"] *,
  [aria-label^="Menu, Sort"][role="combobox"] *,
  [aria-label*="Filter" i][role="combobox"] *,
  [aria-label*="Sort" i][role="combobox"] * {
    color: #fff !important;
    background: transparent !important;
    box-shadow: none !important;
  }

  [aria-label^="Menu, Filter"][role="combobox"] svg,
  [aria-label^="Menu, Sort"][role="combobox"] svg,
  [aria-label*="Filter" i][role="combobox"] svg,
  [aria-label*="Sort" i][role="combobox"] svg {
    display: none !important;
  }

  [aria-label^="Menu, Filter"][role="combobox"]::after,
  [aria-label^="Menu, Sort"][role="combobox"]::after,
  [aria-label*="Filter" i][role="combobox"]::after,
  [aria-label*="Sort" i][role="combobox"]::after {
    color: #fff !important;
    content: '▾' !important;
    font-size: 11px !important;
    line-height: 1 !important;
    margin-left: 2px !important;
  }

  #bv_review_filter_container {
    margin: 32px 0 8px !important;
    min-height: 134px !important;
  }

  #bv_review_filter_container h3 {
    margin: 0 0 8px !important;
    padding: 0 !important;
  }

  #bv_review_filter_container h3,
  #bv_review_filter_container h3 * {
    font-family: "Arial Rounded MT Bold", sans-serif !important;
    font-weight: 400 !important;
    letter-spacing: 0 !important;
  }

  div:has(> #search-input),
  [role="search"]:has(> #search-input) {
    height: 42px !important;
    margin: 0 0 12px !important;
    max-width: 22.5rem !important;
    overflow: visible !important;
    position: relative !important;
    width: 100% !important;
  }

  div:has(> #search-input) > label,
  [role="search"]:has(> #search-input) > label {
    clip: rect(0, 0, 0, 0) !important;
    height: 1px !important;
    overflow: hidden !important;
    position: absolute !important;
    width: 1px !important;
  }

  div:has(> #search-input) svg,
  [role="search"] svg,
  div:has(> #search-input) > div:not(:has(> button)):not(:has(> input)):not(:has(> [role="combobox"])),
  [role="search"] > div:not(:has(> button)):not(:has(> input)):not(:has(> [role="combobox"])) {
    display: none !important;
  }

  div:has(> #search-input) > button:not([role="combobox"]):not([aria-label^="Remove active filter"]):not([aria-label*="Clear all" i]),
  [role="search"] > button:not([role="combobox"]):not([aria-label^="Remove active filter"]) {
    align-items: center !important;
    background: transparent !important;
    border: 0 !important;
    border-radius: 0 !important;
    box-shadow: none !important;
    color: #231f20 !important;
    cursor: pointer !important;
    display: inline-flex !important;
    height: 24px !important;
    justify-content: center !important;
    left: auto !important;
    margin: 0 !important;
    padding: 0 !important;
    position: absolute !important;
    right: 10px !important;
    top: 9px !important;
    transform: none !important;
    width: 24px !important;
    z-index: 2 !important;
  }

  div:has(> #search-input) > button svg,
  [role="search"] > button svg {
    display: block !important;
    height: 12px !important;
    inset: auto !important;
    left: auto !important;
    position: static !important;
    right: auto !important;
    top: auto !important;
    width: 12px !important;
  }

  div:has(> #search-input) > button svg path,
  [role="search"] > button svg path {
    fill: #231f20 !important;
  }

  [data-bf-bv-toolbar] {
    align-items: center !important;
    display: flex !important;
    justify-content: space-between !important;
    margin: 8px 0 !important;
    min-height: 0 !important;
    position: relative !important;
    width: 100% !important;
  }

  [data-bf-bv-toolbar] > :first-child {
    flex: 0 0 auto !important;
    margin-right: auto !important;
    position: static !important;
  }

  [data-bf-bv-sort-cluster] {
    align-items: center !important;
    background: transparent !important;
    column-gap: 8px !important;
    display: grid !important;
    grid-template-columns: max-content 9rem !important;
    height: auto !important;
    margin-left: auto !important;
    position: relative !important;
    white-space: nowrap !important;
    width: max-content !important;
  }

  [data-bf-bv-sort-cluster] > *:first-child {
    grid-column: 1 !important;
  }

  [data-bf-bv-sort-cluster] > *:not(:first-child):not([role="listbox"]) {
    grid-column: 2 !important;
    justify-self: start !important;
  }

  [data-bf-bv-sort-cluster] > *:not([id^="bv-popup"]) {
    background: transparent !important;
    background-color: transparent !important;
    border: 0 !important;
    box-shadow: none !important;
    color: #fff !important;
    height: auto !important;
    min-width: 0 !important;
    width: auto !important;
  }

  /* BV's default sort/filter control is a 40px white box. After search/sort it
     remounts without our data-attribute hooks, so flatten those wrappers via :has(). */
  div:has(> [aria-label^="Menu, Sort"][role="combobox"]),
  div:has(> [aria-label^="Menu, Filter"][role="combobox"]),
  div:has(> [aria-label*="Sort" i][role="combobox"]),
  div:has(> [aria-label*="Filter" i][role="combobox"]),
  div:has(> #bv-dropdown-select-reviews),
  div:has(> select[id*="bv-dropdown"]),
  div:has(> div > [aria-label^="Menu, Sort"][role="combobox"]),
  div:has(> div > [aria-label^="Menu, Filter"][role="combobox"]),
  div:has(> div > [aria-label*="Sort" i][role="combobox"]),
  div:has(> div > [aria-label*="Filter" i][role="combobox"]),
  div:has(> div > #bv-dropdown-select-reviews),
  div:has(> div > div > [aria-label^="Menu, Sort"][role="combobox"]),
  div:has(> div > div > [aria-label^="Menu, Filter"][role="combobox"]),
  div:has(> div > div > [aria-label*="Sort" i][role="combobox"]),
  div:has(> div > div > [aria-label*="Filter" i][role="combobox"]) {
    background: transparent !important;
    background-color: transparent !important;
    border: 0 !important;
    box-shadow: none !important;
    height: auto !important;
    min-height: 0 !important;
    width: auto !important;
  }

  #bv-dropdown-select-reviews,
  #bv-dropdown-title-reviews,
  #bv-dropdown-title-reviews *,
  [aria-label^="Menu, Sort"],
  [aria-label^="Menu, Sort"] > * {
    color: #fff !important;
    background: transparent !important;
    background-color: transparent !important;
  }

  #bv-dropdown-title-reviews,
  #bv-dropdown-title-reviews > * {
    display: block !important;
    max-width: 7.25rem !important;
    min-width: 7.25rem !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
    white-space: nowrap !important;
  }

  [data-bf-bv-sort-cluster] [role="listbox"]:not([data-bf-bv-open]),
  [aria-label^="Menu, Sort"][role="combobox"] ~ [role="listbox"]:not([data-bf-bv-open]),
  #bv_review_filter_container [role="listbox"]:not([data-bf-bv-open]) {
    display: none !important;
    height: 0 !important;
    min-height: 0 !important;
    overflow: hidden !important;
    visibility: hidden !important;
  }

  /* Closed filter/sort listbox wrappers remount as 40px white slabs. */
  #bv_review_filter_container div:has(> [role="listbox"]:not([data-bf-bv-open])):not(:has(> [role="combobox"])):not(:has(> input)),
  [data-bf-bv-sort-cluster] div:has(> [role="listbox"]:not([data-bf-bv-open])):not(:has(> [role="combobox"])) {
    background: transparent !important;
    border: 0 !important;
    box-shadow: none !important;
    display: none !important;
    height: 0 !important;
    min-height: 0 !important;
    overflow: hidden !important;
    visibility: hidden !important;
  }

  #bv_review_filter_container select,
  #bv_review_filter_container [id*="bv-dropdown-select"],
  #bv_review_filter_container [id*="dropdown-select"] {
    clip: rect(0, 0, 0, 0) !important;
    height: 0 !important;
    margin: 0 !important;
    min-height: 0 !important;
    opacity: 0 !important;
    overflow: hidden !important;
    padding: 0 !important;
    pointer-events: none !important;
    position: absolute !important;
    width: 0 !important;
  }

  #bv_review_filter_container div:has(> select),
  #bv_review_filter_container div:has(> [id*="bv-dropdown-select"]) {
    background: transparent !important;
    border: 0 !important;
    box-shadow: none !important;
    height: auto !important;
    min-height: 0 !important;
  }

  button[aria-label^="Remove active filter"],
  button[aria-label*="Remove active filter" i],
  button[aria-label*="Clear all" i],
  button[aria-label^="Clear all" i] {
    align-items: center !important;
    background: transparent !important;
    border: 2px solid #fff !important;
    border-radius: 999px !important;
    box-shadow: none !important;
    color: #fff !important;
    display: inline-flex !important;
    flex-direction: row !important;
    flex-wrap: nowrap !important;
    font-size: 14px !important;
    gap: 6px !important;
    height: auto !important;
    justify-content: center !important;
    line-height: 1.2 !important;
    margin: 0 8px 8px 0 !important;
    min-height: 32px !important;
    min-width: 0 !important;
    overflow: visible !important;
    padding: 4px 12px !important;
    width: auto !important;
  }

  button[aria-label^="Remove active filter"] *,
  button[aria-label*="Remove active filter" i] *,
  button[aria-label*="Clear all" i] *,
  button[aria-label^="Clear all" i] * {
    color: #fff !important;
    fill: #fff !important;
    font-size: 14px !important;
    line-height: 1.2 !important;
    overflow: visible !important;
  }

  button[aria-label^="Remove active filter"] > span,
  button[aria-label*="Remove active filter" i] > span:not(:has(svg)) {
    clip: auto !important;
    clip-path: none !important;
    color: #fff !important;
    display: inline !important;
    font-size: 14px !important;
    height: auto !important;
    overflow: visible !important;
    position: static !important;
    width: auto !important;
  }

  div:has(> [role="listbox"][data-bf-bv-open]) {
    display: block !important;
    height: auto !important;
    overflow: visible !important;
    visibility: visible !important;
    z-index: 1000 !important;
  }

  [role="listbox"][data-bf-bv-open] {
    background: #fff !important;
    border: 2px solid ${BV_INK} !important;
    border-radius: 8px !important;
    box-shadow: none !important;
    color: ${BV_INK} !important;
    display: block !important;
    height: auto !important;
    inset: auto !important;
    max-height: min(260px, 50vh) !important;
    min-width: 10rem !important;
    overflow-x: hidden !important;
    overflow-y: auto !important;
    padding: 4px 0 !important;
    position: fixed !important;
    width: max-content !important;
    z-index: 1000 !important;
  }

  #bv_review_filter_container [role="listbox"][data-bf-bv-open],
  #bv_review_filter_container [role="listbox"][data-bf-bv-open] [role="option"],
  #bv_review_filter_container [role="listbox"][data-bf-bv-open] [role="option"] * {
    color: ${BV_INK} !important;
  }

  [role="listbox"][data-bf-bv-open] [role="option"],
  [role="listbox"][data-bf-bv-open] [role="option"]:first-child,
  [role="listbox"][data-bf-bv-open] [role="option"][aria-selected="true"] {
    background: transparent !important;
    box-sizing: border-box !important;
    color: ${BV_INK} !important;
    display: block !important;
    flex: none !important;
    font-size: 14px !important;
    font-weight: 400 !important;
    height: auto !important;
    justify-content: flex-start !important;
    line-height: 1.3 !important;
    margin: 0 !important;
    min-height: 0 !important;
    padding: 8px 14px !important;
    text-align: left !important;
    white-space: nowrap !important;
  }

  [role="listbox"][data-bf-bv-open] [role="option"] * {
    background: transparent !important;
    color: ${BV_INK} !important;
    display: inline !important;
    font-size: inherit !important;
    font-weight: 400 !important;
    height: auto !important;
    line-height: inherit !important;
    margin: 0 !important;
    min-height: 0 !important;
    padding: 0 !important;
  }

  [data-bf-bv-sort-cluster] [role="listbox"][data-bf-bv-open] [role="option"] svg,
  [data-bf-bv-sort-cluster] [role="listbox"][data-bf-bv-open] [role="option"] img {
    display: none !important;
    height: 0 !important;
    width: 0 !important;
  }

  [data-bf-bv-sort-cluster] [aria-label^="Menu, Sort"] ~ svg,
  [data-bf-bv-sort-cluster] div:has(> [aria-label^="Menu, Sort"]) svg {
    display: none !important;
  }

  [id^="bv-popup"] {
    background: transparent !important;
    border: none !important;
    padding: 0 !important;
    white-space: normal !important;
    width: auto !important;
  }

  [data-bf-bv-sort-cluster] [id^="bv-popup"] {
    left: auto !important;
    position: absolute !important;
    right: 0 !important;
    top: calc(100% + 8px) !important;
    z-index: 20 !important;
  }

  @media (max-width: 749px) {
    [data-bf-bv-toolbar] {
      flex-wrap: wrap !important;
      gap: 8px !important;
    }

    [data-bf-bv-sort-cluster] {
      grid-template-columns: max-content minmax(0, 1fr) !important;
      margin-left: 0 !important;
      max-width: 100% !important;
      width: 100% !important;
    }

    [aria-label^="Menu, Filter"][role="combobox"] {
      margin: 0 16px 8px 0 !important;
    }
  }

  [id^="bv-popup-content"] {
    background: #fff !important;
    border: 2px solid ${BV_INK} !important;
    border-radius: 16px !important;
    box-sizing: border-box !important;
    box-shadow: none !important;
    color: ${BV_INK} !important;
    font-family: ${BV_FONT_BODY} !important;
    font-size: 14px !important;
    line-height: 1.4 !important;
    max-width: min(280px, calc(100vw - 32px)) !important;
    overflow: hidden !important;
    overflow-wrap: break-word !important;
    padding: 16px 36px 16px 16px !important;
    position: relative !important;
    white-space: normal !important;
    width: 280px !important;
    word-wrap: break-word !important;
  }

  [id^="bv-popup-content"],
  [id^="bv-popup-content"] * {
    color: ${BV_INK} !important;
    font-size: 14px !important;
    line-height: 1.4 !important;
    overflow-wrap: break-word !important;
    white-space: normal !important;
  }

  [id^="bv-popup-content"] button[aria-label*="close" i] {
    align-items: center !important;
    background: transparent !important;
    border: 0 !important;
    box-shadow: none !important;
    display: inline-flex !important;
    height: 20px !important;
    justify-content: center !important;
    margin: 0 !important;
    padding: 0 !important;
    position: absolute !important;
    right: 10px !important;
    top: 10px !important;
    width: 20px !important;
  }

  [id^="bv-popup-content"] button[aria-label*="close" i] svg {
    display: none !important;
  }

  [id^="bv-popup-content"] button[aria-label*="close" i]::after {
    color: ${BV_INK} !important;
    content: '×' !important;
    font-size: 18px !important;
    font-weight: 400 !important;
    line-height: 1 !important;
  }

  svg[class*="bv-rnr__jcyw8r"] {
    color: ${BV_YELLOW} !important;
    fill: none !important;
  }

  /* Filled vs empty stars use a linearGradient. Never paint the path solid —
     that makes 1★/4★ reviews look like 5★ and the histogram counts look wrong. */
  svg[class*="bv-rnr__jcyw8r"] stop[offset="0%"] {
    stop-color: ${BV_YELLOW} !important;
  }

  svg[class*="bv-rnr__jcyw8r"] stop:not([offset="0%"]) {
    stop-color: rgba(255, 255, 255, 0.35) !important;
  }

  section[id^="bv-review-"] > div > div {
    gap: 24px !important;
  }

  section[id^="bv-review-"] > div > div > div:first-child {
    flex: 0 0 10rem !important;
    max-width: 10rem !important;
    min-width: 10rem !important;
    width: 10rem !important;
  }

  section[id^="bv-review-"] > div > div > div:last-child {
    flex: 1 1 auto !important;
    max-width: none !important;
    min-width: 0 !important;
  }

  #bf-bv-pagination {
    box-sizing: border-box !important;
    display: block !important;
    flex: 0 0 100% !important;
    height: auto !important;
    margin: 20px 0 24px !important;
    min-width: 100% !important;
    pointer-events: auto !important;
    position: relative !important;
    visibility: visible !important;
    width: 100% !important;
    z-index: 8 !important;
  }

  #bf-bv-pagination .bf-bv-pagination__btns {
    display: flex !important;
    gap: 4px !important;
    justify-content: flex-end !important;
    width: 100% !important;
  }

  #bf-bv-extra-reviews {
    display: none !important;
    width: 100% !important;
  }

  #bf-bv-extra-reviews[data-bf-open="true"] {
    display: block !important;
  }

  .bf-bv-extra-review {
    color: #fff !important;
    display: grid !important;
    gap: 1rem !important;
    grid-template-columns: 10rem minmax(0, 1fr) !important;
    padding: 1.25rem 0 !important;
  }

  .bf-bv-extra-review + .bf-bv-extra-review {
    border-top: 1px solid rgb(255 255 255 / 0.2) !important;
  }

  .bf-bv-extra-review__author {
    font-weight: 700 !important;
  }

  .bf-bv-extra-stars {
    color: #fbcf29 !important;
    font-size: 18px !important;
    letter-spacing: 2px !important;
    line-height: 1 !important;
  }

  .bf-bv-extra-review__date {
    margin-top: 6px !important;
    opacity: 0.85 !important;
  }

  div:has(> ul[role="presentation"] .prev),
  div:has(> div > ul[role="presentation"] .prev) {
    align-items: center !important;
    background: transparent !important;
    color: inherit !important;
    display: flex !important;
    justify-content: space-between !important;
    width: 100% !important;
  }

  ul[role="presentation"]:has(.prev, .next) {
    align-items: center !important;
    display: flex !important;
    gap: 8px !important;
    list-style: none !important;
    margin: 0 0 0 auto !important;
    padding: 0 !important;
  }

  button.prev:not(#bf-bv-pagination .prev),
  button.next:not(#bf-bv-pagination .next),
  a.prev:not(#bf-bv-pagination .prev),
  a.next:not(#bf-bv-pagination .next) {
    display: none !important;
  }

  #bf-bv-pagination button.prev,
  #bf-bv-pagination button.next {
    align-items: center !important;
    background: transparent !important;
    border: 0 !important;
    box-shadow: none !important;
    box-sizing: border-box !important;
    color: #fff !important;
    cursor: pointer !important;
    display: inline-flex !important;
    font-size: 0 !important;
    height: 44px !important;
    justify-content: center !important;
    margin: 0 !important;
    padding: 0 !important;
    pointer-events: auto !important;
    position: relative !important;
    left: auto !important;
    right: auto !important;
    top: auto !important;
    width: 44px !important;
    z-index: 8 !important;
  }

  #bf-bv-pagination button.prev svg,
  #bf-bv-pagination button.next svg {
    display: none !important;
  }

  #bf-bv-pagination button.prev::after,
  #bf-bv-pagination button.next::after {
    color: #fff !important;
    font-family: ${BV_FONT_BODY} !important;
    font-size: 28px !important;
    font-weight: 400 !important;
    line-height: 1 !important;
  }

  #bf-bv-pagination button.prev::after {
    content: '‹' !important;
  }

  #bf-bv-pagination button.next::after {
    content: '›' !important;
  }

  #bf-bv-pagination button.prev:disabled,
  #bf-bv-pagination button.next:disabled {
    cursor: default !important;
    opacity: 0.4 !important;
  }

  [class*="ips_"],
  [class*="ips_"] *:not(svg):not(path):not(stop),
  #review-submission,
  #review-submission *:not(svg):not(path):not(stop),
  [id*="review-submission"],
  [id*="review-submission"] *:not(svg):not(path):not(stop),
  [role="dialog"][class*="ips_"],
  [role="dialog"][class*="ips_"] *:not(svg):not(path):not(stop) {
    color: ${BV_INK} !important;
  }

  [class*="ips_"] input:not([type="checkbox"]):not([type="radio"]):not([type="hidden"]),
  [class*="ips_"] textarea,
  [class*="ips_"] select {
    background: #fff !important;
    border: 2px solid ${BV_INK} !important;
    border-radius: 6px !important;
    color: ${BV_INK} !important;
  }

  [class*="ips_"] textarea {
    height: auto !important;
    min-height: 6.5rem !important;
    max-width: none !important;
  }

  [class*="ips_"] div:has(> button[aria-label*="Start" i]),
  [class*="ips_"] div:has(> button[aria-label*="Stop" i]),
  [class*="ips_"] div:has(> button[aria-label*="Tap" i]) {
    background: transparent !important;
    border: 0 !important;
    box-shadow: none !important;
    height: auto !important;
    margin: 0 !important;
    padding: 8px 0 0 !important;
  }

  [class*="ips_"][role="dialog"],
  #review-submission,
  [id*="review-submission"],
  .bv-ips-modal-window {
    background: #fff !important;
    border-radius: 16px !important;
    box-sizing: border-box !important;
    color: ${BV_INK} !important;
    max-height: min(90vh, calc(100dvh - 24px)) !important;
    overflow-x: hidden !important;
    overflow-y: auto !important;
    overscroll-behavior: contain !important;
  }

  [class*="ips_"] button[aria-label*="close" i],
  [class*="ips_"] button[aria-label*="Close" i],
  [class*="ips_"] button[title*="close" i],
  [id^="bv-popup-content"] button[aria-label*="close" i],
  button[class*="ips_"]:has(> svg):not(:has(span, p, label)):not([role="checkbox"]):not([aria-label*="star" i]):not([aria-label*="Start" i]):not([aria-label*="Stop" i]):not([aria-label*="agree" i]) {
    align-items: center !important;
    background: #fff !important;
    border: 2px solid ${BV_INK} !important;
    border-radius: 6px !important;
    box-sizing: border-box !important;
    color: ${BV_INK} !important;
    cursor: pointer !important;
    display: inline-flex !important;
    height: 42px !important;
    justify-content: center !important;
    padding: 8px !important;
    width: 42px !important;
    z-index: 5 !important;
  }

  [class*="ips_"] button[aria-label*="close" i] svg,
  [class*="ips_"] button[aria-label*="Close" i] svg,
  [class*="ips_"] button[title*="close" i] svg,
  [id^="bv-popup-content"] button[aria-label*="close" i] svg,
  button[class*="ips_"]:has(> svg):not(:has(span, p, label)):not([aria-label*="star" i]) svg {
    height: 16px !important;
    width: 16px !important;
  }

  [class*="ips_"] button[aria-label*="close" i] svg path,
  [class*="ips_"] button[aria-label*="Close" i] svg path,
  [class*="ips_"] button[title*="close" i] svg path,
  [id^="bv-popup-content"] button[aria-label*="close" i] svg path,
  button[class*="ips_"]:has(> svg):not(:has(span, p, label)):not([aria-label*="star" i]) svg path {
    fill: ${BV_INK} !important;
    stroke: ${BV_INK} !important;
  }

  button[aria-label*="star" i]:not([aria-label*="out of" i]) svg path {
    fill: ${BV_YELLOW} !important;
  }
`;

function resetBvReviewStarFills(shadow) {
  shadow.querySelectorAll('svg[class*="bv-rnr__jcyw8r"]').forEach((svg) => {
    if (svg.closest('button[aria-label*="star" i]:not([aria-label*="out of" i])')) return;

    const path = svg.querySelector('path');
    const grad = svg.querySelector('linearGradient');
    if (!path) return;

    path.style.removeProperty('fill');
    svg.style.removeProperty('fill');

    // BV paints stars with fill="url(page#id)". That ID lives in the shadow
    // SVG, so the document URL fails and every star falls back to solid yellow.
    if (grad?.id) {
      path.setAttribute('fill', `url(#${grad.id})`);
    }
  });
}

function flattenBvSortWrapper(node) {
  if (!(node instanceof Element)) return;
  if (node.getAttribute('role') === 'listbox' || node.getAttribute('role') === 'search') return;
  if (node.querySelector?.(':scope > #search-input')) return;
  if (node.id === 'bv_review_filter_container' || node.id === 'bv_review_maincontainer' || node.id === 'reviews_container') return;
  if (node.id && node.id.startsWith('bv-popup')) return;

  node.style.setProperty('background', 'transparent', 'important');
  node.style.setProperty('background-color', 'transparent', 'important');
  node.style.setProperty('border', '0', 'important');
  node.style.setProperty('box-shadow', 'none', 'important');
  node.style.setProperty('height', 'auto', 'important');
  node.style.setProperty('min-height', '0', 'important');
}

function comboFallbackLabel(el) {
  const aria = el.getAttribute('aria-label') || '';
  const match = aria.match(/(?:Menu,\s*)?(?:Filter|Sort)(?:\s+by)?\s+(.+?)(?:\s+currently selected.*)?$/i);
  return match ? match[1].replace(/\s+/g, ' ').trim() : '';
}

function styleBvFilterChip(btn) {
  [
    ['align-items', 'center'],
    ['background', 'transparent'],
    ['border', '2px solid #fff'],
    ['border-radius', '999px'],
    ['color', '#fff'],
    ['display', 'inline-flex'],
    ['flex-direction', 'row'],
    ['font-size', '14px'],
    ['gap', '6px'],
    ['height', 'auto'],
    ['line-height', '1.2'],
    ['min-height', '32px'],
    ['padding', '4px 12px'],
    ['width', 'auto'],
    ['overflow', 'visible'],
  ].forEach(([prop, value]) => {
    btn.style.setProperty(prop, value, 'important');
  });

  btn.querySelectorAll(':scope > span').forEach((span) => {
    if (span.querySelector('svg')) return;
    span.style.setProperty('position', 'static', 'important');
    span.style.setProperty('clip', 'auto', 'important');
    span.style.setProperty('clip-path', 'none', 'important');
    span.style.setProperty('width', 'auto', 'important');
    span.style.setProperty('height', 'auto', 'important');
    span.style.setProperty('overflow', 'visible', 'important');
    span.style.setProperty('font-size', '14px', 'important');
    span.style.setProperty('color', '#fff', 'important');
    span.style.setProperty('display', 'inline', 'important');
  });
}

function restoreBvComboLabels(shadow) {
  shadow.querySelectorAll('[role="combobox"][aria-label*="Filter" i], [role="combobox"][aria-label*="Sort" i]').forEach((el) => {
    const current = (el.textContent || '').replace(/\s+/g, ' ').trim();
    if (current && current !== '▾') return;

    const label = comboFallbackLabel(el);
    if (!label) return;

    const title = el.querySelector('#bv-dropdown-title-reviews, [id^="bv-dropdown-title"]');
    if (title) {
      if (!(title.textContent || '').trim()) title.textContent = label;
      return;
    }

    if (el.querySelector('[data-bf-bv-combo-label]')) return;
    const span = document.createElement('span');
    span.setAttribute('data-bf-bv-combo-label', '');
    span.textContent = label;
    el.insertBefore(span, el.firstChild);
  });

  shadow.querySelectorAll(
    'button[aria-label^="Remove active filter"], button[aria-label*="Remove active filter" i], button[aria-label*="Clear all" i]'
  ).forEach((btn) => {
    styleBvFilterChip(btn);

    if (/clear all/i.test(btn.getAttribute('aria-label') || '') || /^clear all$/i.test((btn.textContent || '').trim())) {
      return;
    }

    const visible = [...btn.querySelectorAll(':scope > span')].some((span) => {
      if (span.querySelector('svg')) return false;
      const text = (span.textContent || '').replace(/[×x✕]|close/gi, '').replace(/\s+/g, ' ').trim();
      return text.length > 0 && getComputedStyle(span).display !== 'none';
    });
    if (visible) return;

    const match = (btn.getAttribute('aria-label') || '').match(/Remove active filter(?:\s+\w+)?[,\s]+(.+?)\.?$/i);
    const label = match ? match[1].trim() : '';
    if (!label) return;
    if (btn.querySelector('[data-bf-bv-chip-label]')) {
      btn.querySelector('[data-bf-bv-chip-label]').textContent = label;
      return;
    }
    const span = document.createElement('span');
    span.setAttribute('data-bf-bv-chip-label', '');
    span.textContent = label;
    btn.insertBefore(span, btn.firstChild);
  });

  shadow.querySelectorAll('button').forEach((btn) => {
    if (!/^clear all$/i.test((btn.textContent || '').replace(/\s+/g, ' ').trim())) return;
    styleBvFilterChip(btn);
  });
}

function hideBvNativeSelect(el) {
  el.style.setProperty('appearance', 'none', 'important');
  el.style.setProperty('background', 'transparent', 'important');
  el.style.setProperty('border', '0', 'important');
  el.style.setProperty('height', '0', 'important');
  el.style.setProperty('width', '0', 'important');
  el.style.setProperty('margin', '0', 'important');
  el.style.setProperty('padding', '0', 'important');
  el.style.setProperty('opacity', '0', 'important');
  el.style.setProperty('position', 'absolute', 'important');
  el.style.setProperty('pointer-events', 'none', 'important');
  el.style.setProperty('overflow', 'hidden', 'important');

  let node = el.parentElement;
  for (let i = 0; i < 4 && node; i += 1) {
    flattenBvSortWrapper(node);
    if (!node.querySelector('[role="combobox"], input, button[aria-label*="filter" i]')) {
      const height = node.getBoundingClientRect().height;
      if (height >= 28 && height <= 48) {
        node.style.setProperty('height', '0', 'important');
        node.style.setProperty('min-height', '0', 'important');
        node.style.setProperty('overflow', 'hidden', 'important');
      }
    }
    node = node.parentElement;
  }
}

function restyleBvSortControls(shadow) {
  shadow.querySelectorAll(
    '#bv-dropdown-select-reviews, select[id*="bv-dropdown"], select[id*="dropdown-select"], #bv_review_filter_container select'
  ).forEach((el) => {
    hideBvNativeSelect(el);
  });

  const filterRoot = shadow.getElementById('bv_review_filter_container');
  if (filterRoot) {
    [...filterRoot.querySelectorAll('div')].forEach((el) => {
      if (el.querySelector('#search-input, input[aria-label^="Search"], [role="combobox"], button[aria-label*="filter" i]')) {
        flattenBvSortWrapper(el);
        return;
      }
      if (!el.querySelector('[role="listbox"]')) return;
      const box = el.getBoundingClientRect();
      if (box.height >= 28 && box.height <= 56 && box.width > 80) {
        el.style.setProperty('display', 'none', 'important');
        el.style.setProperty('height', '0', 'important');
        el.style.setProperty('min-height', '0', 'important');
        el.style.setProperty('overflow', 'hidden', 'important');
        el.style.setProperty('background', 'transparent', 'important');
      }
    });
  }

  shadow.querySelectorAll('[role="combobox"][aria-label*="Filter" i], [role="combobox"][aria-label*="Sort" i]').forEach((el) => {
    el.style.setProperty('background', 'transparent', 'important');
    el.style.setProperty('background-color', 'transparent', 'important');
    el.style.setProperty('border', '0', 'important');
    el.style.setProperty('border-radius', '0', 'important');
    el.style.setProperty('padding', '0', 'important');
    el.style.setProperty('height', 'auto', 'important');
    el.style.setProperty('min-height', '0', 'important');
    el.style.setProperty('min-width', '0', 'important');
    el.style.setProperty('width', 'auto', 'important');
    el.style.setProperty('color', '#fff', 'important');

    const isSort = /sort/i.test(el.getAttribute('aria-label') || '');
    let node = el.parentElement;
    const depth = isSort ? 4 : 3;
    for (let i = 0; i < depth && node && node !== shadow; i += 1) {
      flattenBvSortWrapper(node);
      node = node.parentElement;
    }
  });

  shadow.querySelectorAll('[data-bf-bv-sort-cluster] > *').forEach((child) => {
    if (child.getAttribute('role') === 'listbox') return;
    if (child.id && child.id.startsWith('bv-popup')) return;
    flattenBvSortWrapper(child);
    child.style.setProperty('width', 'auto', 'important');
    child.style.setProperty('min-width', '0', 'important');
  });

  restoreBvComboLabels(shadow);
  restyleBvSearch(shadow);
}

function isBvSearchClearButton(node) {
  if (!(node instanceof Element) || node.tagName !== 'BUTTON') return false;
  const label = `${node.getAttribute('aria-label') || ''} ${node.textContent || ''}`;
  return /Clear Search/i.test(label);
}

function restyleBvSearch(shadow) {
  const search = shadow.querySelector('#search-input, input[aria-label^="Search"]');
  if (!search) return;

  search.style.setProperty('box-sizing', 'border-box', 'important');
  search.style.setProperty('height', '42px', 'important');
  search.style.setProperty('min-height', '42px', 'important');
  search.style.setProperty('max-width', 'none', 'important');
  search.style.setProperty('width', '100%', 'important');
  search.style.setProperty('font-size', '14px', 'important');
  search.style.setProperty('line-height', '1.2', 'important');
  search.style.setProperty('padding', '8px 40px 8px 12px', 'important');
  search.style.setProperty('border', '2px solid #231f20', 'important');
  search.style.setProperty('border-radius', '6px', 'important');
  search.style.setProperty('background', '#fff', 'important');
  search.style.setProperty('background-image', 'none', 'important');

  if (search.dataset.bfSearchBound !== 'true') {
    search.dataset.bfSearchBound = 'true';
    search.addEventListener('input', () => {
      search.style.setProperty('background-image', 'none', 'important');
    });
  }

  const wrap = search.parentElement;
  if (!wrap) return;

  wrap.style.setProperty('max-width', '22.5rem', 'important');
  wrap.style.setProperty('width', '100%', 'important');
  wrap.style.setProperty('height', '42px', 'important');
  wrap.style.setProperty('position', 'relative', 'important');
  wrap.style.setProperty('overflow', 'visible', 'important');

  [...wrap.children].forEach((node) => {
    if (node === search || node.tagName === 'LABEL' || search.contains(node)) return;
    const label = `${node.getAttribute('aria-label') || ''} ${node.textContent || ''}`;
    if (/Remove active filter|Clear all/i.test(label)) return;

    if (isBvSearchClearButton(node)) {
      [
        ['display', 'inline-flex'],
        ['position', 'absolute'],
        ['right', '10px'],
        ['top', '9px'],
        ['left', 'auto'],
        ['bottom', 'auto'],
        ['transform', 'none'],
        ['width', '24px'],
        ['height', '24px'],
        ['background', 'transparent'],
        ['border', '0'],
        ['padding', '0'],
        ['margin', '0'],
        ['z-index', '2'],
      ].forEach(([prop, value]) => node.style.setProperty(prop, value, 'important'));
      node.querySelectorAll('svg').forEach((svg) => {
        svg.style.setProperty('position', 'static', 'important');
        svg.style.setProperty('inset', 'auto', 'important');
        svg.style.setProperty('width', '12px', 'important');
        svg.style.setProperty('height', '12px', 'important');
        svg.style.setProperty('display', 'block', 'important');
      });
      return;
    }

    node.style.setProperty('display', 'none', 'important');
  });
}

function stabilizeBvFilterChrome(shadow) {
  const main = shadow.getElementById('bv_review_maincontainer');
  if (!main) return;

  main.querySelectorAll('[data-bf-bv-filter-gap]').forEach((el) => {
    el.style.removeProperty('margin-top');
    el.removeAttribute('data-bf-bv-filter-gap');
  });

  const filter = shadow.getElementById('bv_review_filter_container');
  if (filter) {
    const h = Math.max(134, Math.round(filter.getBoundingClientRect().height));
    filter.style.setProperty('min-height', `${h}px`, 'important');
    main.dataset.bfBvFilterH = String(h);
    main.dataset.bfBvFilterIndex = String([...main.children].indexOf(filter));
    return;
  }

  const h = Number(main.dataset.bfBvFilterH) || 134;
  const idx = Number(main.dataset.bfBvFilterIndex);
  const ratingsOnly = [...main.querySelectorAll('h3')].find((el) => /ratings-only reviews/i.test(el.textContent || ''));
  const target =
    main.children[idx] ||
    ratingsOnly?.closest('#bv_review_maincontainer > *') ||
    main.lastElementChild;
  if (!target) return;
  target.setAttribute('data-bf-bv-filter-gap', '');
  target.style.setProperty('margin-top', `${h}px`, 'important');
}

function restyleBvChrome(shadow) {
  restyleBvSearch(shadow);

  restyleBvSortControls(shadow);
  resetBvReviewStarFills(shadow);

  syncBvListboxes(shadow);

  shadow.querySelectorAll('[id^="bv-popup-content"]').forEach((popup) => {
    popup.style.setProperty('white-space', 'normal', 'important');
    popup.style.setProperty('width', '280px', 'important');
    popup.style.setProperty('max-width', 'min(280px, calc(100vw - 32px))', 'important');
    popup.style.setProperty('overflow', 'hidden', 'important');
    popup.style.setProperty('padding', '16px 36px 16px 16px', 'important');

    popup.querySelectorAll('button[aria-label*="close" i]').forEach((btn) => {
      btn.style.setProperty('background', 'transparent', 'important');
      btn.style.setProperty('border', '0', 'important');
      btn.style.setProperty('height', '20px', 'important');
      btn.style.setProperty('width', '20px', 'important');
      btn.style.setProperty('margin', '0', 'important');
      btn.style.setProperty('padding', '0', 'important');
      btn.style.setProperty('position', 'absolute', 'important');
      btn.style.setProperty('top', '10px', 'important');
      btn.style.setProperty('right', '10px', 'important');
      btn.querySelectorAll('svg').forEach((svg) => {
        svg.style.setProperty('display', 'none', 'important');
      });
    });
  });


  shadow.querySelectorAll('section[id^="bv-review-"] h3, #reviews_container section h3').forEach((title) => {
    title.style.setProperty('font-family', '"Arial Rounded MT Bold", sans-serif', 'important');
    title.style.setProperty('font-weight', '400', 'important');
    title.querySelectorAll('*').forEach((node) => {
      node.style.setProperty('font-family', '"Arial Rounded MT Bold", sans-serif', 'important');
      node.style.setProperty('font-weight', '400', 'important');
    });
  });

  shadow.querySelectorAll('section[id^="bv-review-"] > div > div > div:first-child').forEach((col) => {
    col.style.setProperty('flex', '0 0 10rem', 'important');
    col.style.setProperty('width', '10rem', 'important');
    col.style.setProperty('min-width', '10rem', 'important');
    col.style.setProperty('max-width', '10rem', 'important');
  });

  shadow.querySelectorAll('div:has(> ul[role="presentation"] .prev), div:has(> div > ul[role="presentation"] .prev)').forEach((bar) => {
    bar.style.setProperty('background', 'transparent', 'important');
    bar.style.setProperty('color', 'inherit', 'important');
  });

  shadow.querySelectorAll('button.prev, button.next, a.prev, a.next').forEach((btn) => {
    if (btn.closest('#bf-bv-pagination')) return;
    btn.style.setProperty('display', 'none', 'important');
  });

  restyleBvSubmission(shadow);
  mountBvPagination(shadow);
}

function parseBvPageInfo(shadow) {
  const nodes = [...shadow.querySelectorAll('div')].filter((el) => {
    if (el.children.length) return false;
    return /^\s*\d+\s*[–-]\s*\d+\s+of\s+\d+/i.test((el.textContent || '').replace(/\s+/g, ' ').trim());
  });
  if (!nodes.length) return null;
  const node = nodes[0];
  const match = (node.textContent || '').replace(/\s+/g, ' ').match(/(\d+)\s*[–-]\s*(\d+)\s+of\s+(\d+)/i);
  if (!match) return null;
  return { start: Number(match[1]), end: Number(match[2]), total: Number(match[3]), nodes };
}

function getBvReviewSections(shadow) {
  return [...shadow.querySelectorAll('#reviews_container > section[id^="bv-review-"]')];
}

function hideStrayBvPagers(shadow) {
  shadow.querySelectorAll('button.prev, button.next, a.prev, a.next').forEach((btn) => {
    btn.style.setProperty('display', 'none', 'important');
  });
  shadow.getElementById('bf-bv-pagination')?.remove();
  shadow.getElementById('bf-bv-pagination-bottom')?.remove();
}

function getBvPagerNav() {
  return document.getElementById('bf-bv-pagination');
}

function findBvRatingsOnlyHeading(shadow) {
  return [...shadow.querySelectorAll('h2, h3, div')].find((el) =>
    /^\s*\d+\s+Ratings-Only Reviews?\s*$/i.test((el.textContent || '').replace(/\s+/g, ' ').trim()),
  );
}

function escapeBvText(value) {
  return String(value || '').replace(/[&<>"']/g, (ch) => ({
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;',
  })[ch]);
}

function formatBvAge(iso) {
  const days = Math.max(0, Math.round((Date.now() - Date.parse(iso)) / 86400000));
  if (days < 1) return 'today';
  if (days < 30) return `${days} day${days === 1 ? '' : 's'} ago`;
  const months = Math.max(1, Math.round(days / 30));
  if (months < 12) return `${months} month${months === 1 ? '' : 's'} ago`;
  const years = Math.max(1, Math.round(months / 12));
  return `${years} year${years === 1 ? '' : 's'} ago`;
}

function getBvPagerMeta(shadow, nav = getBvPagerNav()) {
  const sections = getBvReviewSections(shadow);
  const info = parseBvPageInfo(shadow);
  const written = sections.length;
  const total = Number(nav?.dataset.bfTotal) || info?.total || written;
  const page = Math.max(1, Number(nav?.dataset.bfPage) || Number(shadow.host?.dataset.bfBvPage) || 1);
  const pages = total > written ? 2 : 1;
  return { sections, info, written, total, page, pages };
}

function styleBvPager(nav) {
  nav.style.setProperty('display', 'block', 'important');
  nav.style.setProperty('width', '100%', 'important');
  nav.style.setProperty('min-width', '100%', 'important');
  nav.style.setProperty('flex', '0 0 100%', 'important');
  nav.style.setProperty('margin', '20px 0 24px', 'important');
  nav.style.setProperty('background', 'transparent', 'important');
  nav.querySelectorAll('button').forEach((btn) => {
    btn.style.setProperty('background', 'transparent', 'important');
    btn.style.setProperty('border', '0', 'important');
    btn.style.setProperty('box-shadow', 'none', 'important');
    btn.style.setProperty('color', '#fff', 'important');
    btn.style.setProperty('cursor', btn.disabled ? 'default' : 'pointer', 'important');
    btn.style.setProperty('display', 'inline-flex', 'important');
    btn.style.setProperty('align-items', 'center', 'important');
    btn.style.setProperty('justify-content', 'center', 'important');
    btn.style.setProperty('width', '44px', 'important');
    btn.style.setProperty('height', '44px', 'important');
    btn.style.setProperty('padding', '0', 'important');
    btn.style.setProperty('font-size', '0', 'important');
    btn.style.setProperty('pointer-events', 'auto', 'important');
    btn.style.setProperty('position', 'relative', 'important');
    btn.style.setProperty('z-index', '20', 'important');
  });
}

function ensureBvExtraReviews(shadow, reviews) {
  let extra = shadow.getElementById('bf-bv-extra-reviews');
  if (!extra) {
    extra = document.createElement('div');
    extra.id = 'bf-bv-extra-reviews';
  }
  if (extra.previousElementSibling !== reviews) reviews.after(extra);
  return extra;
}

function renderBvExtraReview(review) {
  const section = document.createElement('section');
  section.id = `bv-review-${review.Id}`;
  section.className = 'bf-bv-extra-review';
  const filled = Number(review.Rating) || 0;
  const stars = Array.from({ length: 5 }, (_, index) =>
    `<span style="opacity:${index < filled ? 1 : 0.25}">★</span>`,
  ).join('');
  section.innerHTML = `
    <div class="bf-bv-extra-review__author">${escapeBvText(review.UserNickname || 'Anonymous')}</div>
    <div class="bf-bv-extra-review__body">
      <div class="bf-bv-extra-stars" aria-label="${filled} out of 5 stars.">${stars}</div>
      <div class="bf-bv-extra-review__date">${escapeBvText(formatBvAge(review.SubmissionTime))}</div>
    </div>
  `;
  return section;
}

async function loadBvRatingsOnly(shadow) {
  const host = shadow.host;
  if (host._bfBvRatingsOnly) return host._bfBvRatingsOnly;
  const productId = host.getAttribute('data-bv-product-id');
  const passkey = window.BV?.swat_reviews?.config?.apiKey;
  if (!productId || !passkey) return [];
  const url =
    `https://api.bazaarvoice.com/data/reviews.json?apiversion=5.4&passkey=${encodeURIComponent(passkey)}` +
    `&Filter=ProductId:${encodeURIComponent(productId)}&Filter=IsRatingsOnly:eq:true&Limit=50&Offset=0`;
  const res = await fetch(url);
  const json = await res.json();
  host._bfBvRatingsOnly = json.Results || [];
  return host._bfBvRatingsOnly;
}

function applyBvPage(shadow, page) {
  const nav = getBvPagerNav();
  const extra = shadow.getElementById('bf-bv-extra-reviews');
  const meta = getBvPagerMeta(shadow, nav);
  const heading = findBvRatingsOnlyHeading(shadow);
  const onExtra = page > 1;

  meta.sections.forEach((section) => {
    section.style.setProperty('display', onExtra ? 'none' : 'block', 'important');
  });
  if (extra) extra.dataset.bfOpen = onExtra ? 'true' : 'false';
  if (heading) {
    if (onExtra) heading.style.setProperty('display', 'none', 'important');
    else heading.style.removeProperty('display');
  }

  if (meta.info) {
    const start = onExtra ? meta.written + 1 : 1;
    const end = onExtra ? meta.total : meta.written;
    const label = `${start} – ${end} of ${meta.total} Reviews`;
    meta.info.nodes.forEach((node) => {
      node.textContent = label;
    });
  }

  shadow.host.dataset.bfBvPage = String(page);
  if (nav) nav.dataset.bfPage = String(page);
  mountBvPagination(shadow);
}

function getBvPagerButton(event) {
  return (event.composedPath?.() || []).find(
    (node) => node instanceof HTMLButtonElement && node.closest?.('#bf-bv-pagination'),
  );
}

function injectBvPagerDocStyles() {
  if (document.getElementById('bf-bv-pager-styles')) return;
  const style = document.createElement('style');
  style.id = 'bf-bv-pager-styles';
  style.textContent = `
    #bf-bv-pagination {
      box-sizing: border-box;
      display: block;
      margin: 20px 0 24px;
      pointer-events: auto;
      position: relative;
      width: 100%;
      z-index: 20;
    }
    #bf-bv-pagination .bf-bv-pagination__btns {
      display: flex;
      gap: 4px;
      justify-content: flex-end;
      width: 100%;
    }
    #bf-bv-pagination button.prev,
    #bf-bv-pagination button.next {
      align-items: center;
      background: transparent;
      border: 0;
      box-shadow: none;
      color: #fff;
      cursor: pointer;
      display: inline-flex;
      font-size: 0;
      height: 44px;
      justify-content: center;
      margin: 0;
      padding: 0;
      pointer-events: auto;
      position: relative;
      width: 44px;
      z-index: 20;
    }
    #bf-bv-pagination button.prev::after,
    #bf-bv-pagination button.next::after {
      color: #fff;
      font-family: ${BV_FONT_BODY};
      font-size: 28px;
      font-weight: 400;
      line-height: 1;
    }
    #bf-bv-pagination button.prev::after { content: '‹'; }
    #bf-bv-pagination button.next::after { content: '›'; }
    #bf-bv-pagination button.prev:disabled,
    #bf-bv-pagination button.next:disabled {
      cursor: default;
      opacity: 0.4;
    }
  `;
  document.head.appendChild(style);
}

function bindBvPaginationClicks() {
  injectBvPagerDocStyles();
  if (document.documentElement.dataset.bfBvPagerBound === 'true') return;
  document.documentElement.dataset.bfBvPagerBound = 'true';

  const activate = (event) => {
    const btn = getBvPagerButton(event);
    if (!btn || btn.disabled) return;
    event.preventDefault();
    event.stopPropagation();
    const host = document.querySelector('[data-bv-show="reviews"]');
    const shadow = host?.shadowRoot;
    if (!shadow) return;
    const delta = btn.classList.contains('next') ? 1 : btn.classList.contains('prev') ? -1 : 0;
    if (!delta) return;
    stepBvPage(shadow, delta);
  };

  document.addEventListener('pointerup', activate, true);
  document.addEventListener('click', activate, true);
}

function bindBvPagerButtons(shadow, nav) {
  const prev = nav.querySelector('.prev');
  const next = nav.querySelector('.next');
  if (prev) {
    prev.onclick = (event) => {
      event.preventDefault();
      stepBvPage(shadow, -1);
    };
  }
  if (next) {
    next.onclick = (event) => {
      event.preventDefault();
      stepBvPage(shadow, 1);
    };
  }
}

function mountBvPagination(shadow) {
  hideStrayBvPagers(shadow);
  bindBvPaginationClicks();
  const host = shadow.host;
  let nav = getBvPagerNav();
  const meta = getBvPagerMeta(shadow, nav);

  if (meta.pages <= 1) {
    nav?.remove();
    shadow.getElementById('bf-bv-extra-reviews')?.remove();
    return;
  }

  const reviews = shadow.getElementById('reviews_container');
  if (!reviews || !host) return;

  ensureBvExtraReviews(shadow, reviews);

  if (!nav) {
    nav = document.createElement('div');
    nav.id = 'bf-bv-pagination';
    nav.innerHTML =
      '<div class="bf-bv-pagination__btns"><button type="button" class="prev" aria-label="Previous">Previous</button><button type="button" class="next" aria-label="Next">Next</button></div>';
  }

  if (nav.previousElementSibling !== host) host.after(nav);
  bindBvPagerButtons(shadow, nav);

  nav.dataset.bfPage = String(meta.page);
  nav.dataset.bfTotal = String(meta.total);
  host.dataset.bfBvPage = String(meta.page);
  nav.querySelector('.prev').disabled = meta.page <= 1;
  nav.querySelector('.next').disabled = meta.page >= meta.pages;
  styleBvPager(nav);
}

let bvPagerStepLock = false;

async function stepBvPage(shadow, delta) {
  if (bvPagerStepLock) return;
  bvPagerStepLock = true;
  try {
    const nav = getBvPagerNav();
    const meta = getBvPagerMeta(shadow, nav);
    const next = meta.page + delta;
    if (next < 1 || next > meta.pages) return;

    if (next > 1) {
      const extra = ensureBvExtraReviews(shadow, shadow.getElementById('reviews_container'));
      if (!extra.dataset.bfFilled) {
        const reviews = await loadBvRatingsOnly(shadow);
        extra.replaceChildren(...reviews.map(renderBvExtraReview));
        extra.dataset.bfFilled = 'true';
      }
    }

    applyBvPage(shadow, next);
  } catch (error) {
    console.warn('[bf-bv] pagination step failed', error);
  } finally {
    bvPagerStepLock = false;
  }
}

function resetBvIpsChoiceControls(root) {
  if (!root?.querySelectorAll) return;

  root.querySelectorAll('input[type="checkbox"], input[type="radio"], [role="checkbox"], [role="radio"]').forEach((el) => {
    [
      'appearance',
      '-webkit-appearance',
      'width',
      'height',
      'min-width',
      'min-height',
      'margin',
      'padding',
      'opacity',
      'visibility',
      'display',
      'border',
      'background',
      'position',
    ].forEach((prop) => {
      el.style.removeProperty(prop);
    });
  });
}

function restyleBvSubmission(shadow) {
  const ips = shadow.querySelector('[class*="ips_"], #review-submission, [id*="review-submission"]');
  if (!ips && !shadow.querySelector('[class*="ips_"]')) return;

  shadow.querySelectorAll('[class*="ips_"]').forEach((node) => {
    if (node.matches('svg, path, polyline, stop, img, button, input, textarea, select, [role="checkbox"], [role="radio"]')) return;
    const text = (node.textContent || '').trim();
    if (/^in progress$/i.test(text)) return;
    node.style.setProperty('color', '#231f20', 'important');
  });

  shadow.querySelectorAll('[class*="ips_"] textarea, [class*="ips_"] input:not([type="hidden"]):not([type="checkbox"]):not([type="radio"])').forEach((field) => {
    field.style.setProperty('background', '#fff', 'important');
    field.style.setProperty('border', '2px solid #231f20', 'important');
    field.style.setProperty('border-radius', '6px', 'important');
    field.style.setProperty('color', '#231f20', 'important');
    if (field.tagName === 'TEXTAREA') {
      field.style.setProperty('height', 'auto', 'important');
      field.style.setProperty('min-height', '6.5rem', 'important');
      field.style.setProperty('max-width', 'none', 'important');
    }
  });

  resetBvIpsChoiceControls(shadow);

  shadow.querySelectorAll('button').forEach((btn) => {
    const label = `${btn.getAttribute('aria-label') || ''} ${btn.textContent || ''}`.toLowerCase();
    if (!/tap to start|start\/stop|start stop/.test(label)) return;

    let node = btn.parentElement;
    while (node && node !== shadow) {
      const height = node.getBoundingClientRect().height;
      if (height > 40 && height < 120) {
        node.style.setProperty('border', '0', 'important');
        node.style.setProperty('border-top', '0', 'important');
        node.style.setProperty('border-left', '0', 'important');
        node.style.setProperty('border-right', '0', 'important');
        node.style.setProperty('border-bottom', '0', 'important');
        node.style.setProperty('box-shadow', 'none', 'important');
        node.style.setProperty('background', 'transparent', 'important');
        node.style.setProperty('height', 'auto', 'important');
        break;
      }
      node = node.parentElement;
    }
  });

  shadow.querySelectorAll('button[aria-label*="star" i]:not([aria-label*="out of" i]) svg path').forEach((path) => {
    path.style.setProperty('fill', '#fbcf29', 'important');
  });


  shadow.querySelectorAll('button').forEach((btn) => {
    const label = `${btn.getAttribute('aria-label') || ''} ${btn.getAttribute('title') || ''}`.toLowerCase();
    if (btn.classList.contains('prev') || btn.classList.contains('next')) return;
    if (btn.closest('ul[role="presentation"]')) return;

    const isClose = /close|dismiss/.test(label);
    if (!isClose) return;
    if (/close popup/i.test(label) || btn.closest('[id^="bv-popup-content"]')) return;

    btn.style.setProperty('align-items', 'center', 'important');
    btn.style.setProperty('background', '#fff', 'important');
    btn.style.setProperty('border', '2px solid #231f20', 'important');
    btn.style.setProperty('border-radius', '6px', 'important');
    btn.style.setProperty('box-sizing', 'border-box', 'important');
    btn.style.setProperty('color', '#231f20', 'important');
    btn.style.setProperty('display', 'inline-flex', 'important');
    btn.style.setProperty('height', '42px', 'important');
    btn.style.setProperty('justify-content', 'center', 'important');
    btn.style.setProperty('padding', '8px', 'important');
    btn.style.setProperty('width', '42px', 'important');
    btn.style.setProperty('z-index', '5', 'important');

    btn.querySelectorAll('svg').forEach((svg) => {
      svg.style.setProperty('width', '16px', 'important');
      svg.style.setProperty('height', '16px', 'important');
    });
    btn.querySelectorAll('svg path').forEach((path) => {
      path.style.setProperty('fill', '#231f20', 'important');
      path.style.setProperty('stroke', '#231f20', 'important');
    });
  });
}

function findListboxCombo(shadow, listbox) {
  const id = listbox.id;
  if (id) {
    const owned = shadow.querySelector(`[aria-controls="${CSS.escape(id)}"], [aria-owns="${CSS.escape(id)}"]`);
    if (owned) return owned;
  }

  return [...shadow.querySelectorAll('[role="combobox"][aria-expanded="true"]')].find((combo) => {
    const controls = combo.getAttribute('aria-controls') || combo.getAttribute('aria-owns') || '';
    return controls === listbox.id || combo.contains(listbox) || combo.parentElement?.contains(listbox);
  }) || null;
}

function revealListboxWrapper(listbox, open) {
  const wrap = listbox.parentElement;
  if (!(wrap instanceof Element)) return;

  ['display', 'visibility', 'height', 'overflow', 'position', 'z-index', 'top', 'left', 'right', 'width'].forEach((prop) => {
    wrap.style.removeProperty(prop);
  });

  if (!open) return;

  wrap.style.setProperty('display', 'block', 'important');
  wrap.style.setProperty('visibility', 'visible', 'important');
  wrap.style.setProperty('height', 'auto', 'important');
  wrap.style.setProperty('overflow', 'visible', 'important');
  wrap.style.setProperty('position', 'absolute', 'important');
  wrap.style.setProperty('z-index', '1000', 'important');
}

function syncBvListboxes(shadow) {
  shadow.querySelectorAll('[role="listbox"]').forEach((listbox) => {
    const combo = findListboxCombo(shadow, listbox);
    const open =
      combo?.getAttribute('aria-expanded') === 'true' ||
      listbox.getAttribute('aria-hidden') === 'false';

    ['background', 'background-clip', 'border', 'border-radius', 'overflow', 'color', 'position', 'z-index', 'display', 'top', 'left', 'right', 'inset', 'height', 'width', 'min-width'].forEach((prop) => {
      listbox.style.removeProperty(prop);
    });

    if (open && combo) {
      const rect = combo.getBoundingClientRect();
      listbox.setAttribute('data-bf-bv-open', '');
      revealListboxWrapper(listbox, true);
      listbox.style.setProperty('display', 'block', 'important');
      listbox.style.setProperty('position', 'fixed', 'important');
      listbox.style.setProperty('top', `${Math.round(rect.bottom + 6)}px`, 'important');
      listbox.style.setProperty('left', `${Math.round(rect.left)}px`, 'important');
      listbox.style.setProperty('right', 'auto', 'important');
      listbox.style.setProperty('height', 'auto', 'important');
      listbox.style.setProperty('min-width', `${Math.max(Math.round(rect.width), 160)}px`, 'important');
      listbox.style.setProperty('z-index', '1000', 'important');

      listbox.querySelectorAll('[role="option"]').forEach((option) => {
        option.style.setProperty('flex', 'none', 'important');
        option.style.setProperty('height', 'auto', 'important');
        option.style.setProperty('min-height', '0', 'important');
        option.style.setProperty('margin', '0', 'important');
        option.style.setProperty('padding', '8px 14px', 'important');
        option.style.setProperty('text-align', 'left', 'important');
        if (listbox.closest('[data-bf-bv-sort-cluster]') || /^Menu, Sort/i.test(combo.getAttribute('aria-label') || '')) {
          option.querySelectorAll('svg, img').forEach((node) => {
            node.style.setProperty('display', 'none', 'important');
          });
        }
        option.querySelectorAll('*').forEach((node) => {
          node.style.setProperty('padding', '0', 'important');
          node.style.setProperty('margin', '0', 'important');
          node.style.setProperty('height', 'auto', 'important');
          node.style.setProperty('min-height', '0', 'important');
        });
      });
    } else {
      listbox.removeAttribute('data-bf-bv-open');
      revealListboxWrapper(listbox, false);
    }
  });
}

function applyBvToolbarStyles(shadow) {
  const compact = window.matchMedia('(max-width: 749px)').matches;

  shadow.querySelectorAll('[data-bf-bv-toolbar]').forEach((toolbar) => {
    toolbar.style.setProperty('display', 'flex', 'important');
    toolbar.style.setProperty('justify-content', 'space-between', 'important');
    toolbar.style.setProperty('align-items', 'center', 'important');
    toolbar.style.setProperty('width', '100%', 'important');
    toolbar.style.setProperty('flex-wrap', compact ? 'wrap' : 'nowrap', 'important');
  });

  shadow.querySelectorAll('[data-bf-bv-sort-cluster]').forEach((cluster) => {
    cluster.style.setProperty('display', 'grid', 'important');
    cluster.style.setProperty('grid-template-columns', compact ? 'max-content minmax(0, 1fr)' : 'max-content 9rem', 'important');
    cluster.style.setProperty('column-gap', '8px', 'important');
    cluster.style.setProperty('align-items', 'center', 'important');
    cluster.style.setProperty('margin-left', compact ? '0' : 'auto', 'important');
    cluster.style.setProperty('width', compact ? '100%' : 'max-content', 'important');
    cluster.style.setProperty('position', 'relative', 'important');
    cluster.style.setProperty('white-space', 'nowrap', 'important');
  });
}

function markBvToolbar(shadow) {
  const combo =
    shadow.querySelector('[aria-label^="Menu, Sort"][role="combobox"]') ||
    shadow.querySelector('[role="combobox"][aria-label*="Sort" i]');
  if (!combo) return;

  if (!combo.closest('[data-bf-bv-toolbar]')) {
    let node = combo.parentElement;

    while (node && node !== shadow) {
      const text = node.textContent || '';

      if (/of \d+\s+Reviews/i.test(text) && /Sort by/i.test(text)) {
        node.setAttribute('data-bf-bv-toolbar', '');
        break;
      }

      node = node.parentElement;
    }
  }

  const toolbar = combo.closest('[data-bf-bv-toolbar]');
  if (toolbar) {
    const sortCol = [...toolbar.children].find((child) => child.contains(combo));
    if (sortCol) {
      let cluster = sortCol;
      if (
        sortCol.children.length === 1 &&
        sortCol.firstElementChild?.contains(combo)
      ) {
        cluster = sortCol.firstElementChild;
      }
      cluster.setAttribute('data-bf-bv-sort-cluster', '');
    }
  }

  applyBvToolbarStyles(shadow);
}

function injectStyleIntoShadow(shadow) {
  if (!shadow) return;

  let style = shadow.getElementById(BV_SHADOW_STYLE_ID);

  if (!style) {
    style = document.createElement('style');
    style.id = BV_SHADOW_STYLE_ID;
    shadow.appendChild(style);
  }

  if (style.textContent !== BV_SHADOW_CSS) {
    style.textContent = BV_SHADOW_CSS;
  }

  const host = shadow.host;
  const isReviewsHost = host?.getAttribute('data-bv-show') === 'reviews';
  const hasIps = Boolean(shadow.querySelector('[class*="ips_"], #review-submission, [id*="review-submission"]'));

  if (isReviewsHost) {
    stabilizeBvFilterChrome(shadow);
    if (host.dataset.bfBvChromeDone === 'true') {
      markBvToolbar(shadow);
      restyleBvSortControls(shadow);
      resetBvReviewStarFills(shadow);
      syncBvListboxes(shadow);
      mountBvPagination(shadow);
      if (hasIps) restyleBvSubmission(shadow);
      return;
    }

    markBvToolbar(shadow);
    restyleBvChrome(shadow);

    if (shadow.querySelector('[data-bf-bv-toolbar]')) {
      host.dataset.bfBvChromeDone = 'true';
    }

    return;
  }

  if (hasIps) restyleBvSubmission(shadow);
}

function injectBvReviewsShadow() {
  const host = document.querySelector('[data-bv-show="reviews"]');
  if (!host) return;
  attachReviewsObserver(host);
  if (host.shadowRoot) injectStyleIntoShadow(host.shadowRoot);
}

function restyleLightIps() {
  document
    .querySelectorAll(
      '[class*="ips_"][role="dialog"], #review-submission, [id*="review-submission"], .bv-ips-modal-window, body > [class*="ips_"]'
    )
    .forEach((host) => {
      restyleBvSubmission(host);
      host.querySelectorAll('h1, h2, h3, h4, label, legend, p, span, small, em, strong, li').forEach((el) => {
        if (/visually-hidden|sr-only|hidden/i.test(String(el.className || ''))) return;
        el.style.setProperty('color', '#231f20', 'important');
        el.style.setProperty('opacity', '1', 'important');
        el.style.setProperty('visibility', 'visible', 'important');
      });
    });
}

function eachOpenShadowHost(fn) {
  const stack = [document.body];

  while (stack.length) {
    const el = stack.pop();
    if (!(el instanceof Element)) continue;
    if (el.shadowRoot) fn(el);
    stack.push(...el.children);
  }
}

function injectBvIpsShadows() {
  if (!document.body) return;

  restyleLightIps();

  const report = {
    hosts: 0,
    ips: 0,
    injected: 0,
    skipped: [],
  };

  eachOpenShadowHost((el) => {
    report.hosts += 1;
    const bvShow = el.getAttribute('data-bv-show');
    if (bvShow && bvShow !== 'inpage_submission') {
      report.skipped.push(`${el.tagName}[data-bv-show=${bvShow}]`);
      return;
    }

    attachIpsShadowObserver(el);

    const hasIps = Boolean(
      el.shadowRoot.querySelector(
        '[class*="ips_"], #review-submission, [id*="review-submission"], .bv-ips-modal-window'
      )
    );

    if (!hasIps) {
      report.skipped.push(`${el.tagName}#${el.id || ''} no-ips`);
      return;
    }

    report.ips += 1;
    injectStyleIntoShadow(el.shadowRoot);
    report.injected += 1;
    console.log('[bf-bv] injected ips shadow', {
      tag: el.tagName,
      id: el.id,
      cls: String(el.className).slice(0, 80),
      hasStyle: Boolean(el.shadowRoot.getElementById(BV_SHADOW_STYLE_ID)),
    });
  });

  console.log('[bf-bv] ips chrome', report);
}

let bvRestyleScheduled = false;
let bvMutating = false;
let bvIpsScheduled = false;

function injectBvModalLockStyles() {
  if (document.getElementById('bf-bv-modal-lock')) return;

  const style = document.createElement('style');
  style.id = 'bf-bv-modal-lock';
  style.textContent = `
    html.bf-bv-modal-open,
    html.bf-bv-modal-open body {
      overflow: hidden !important;
    }
  `;
  document.head.appendChild(style);
}

function injectBvDocumentIpsStyles() {
  const css = `
    [class*="ips_"][role="dialog"],
    #review-submission,
    [id*="review-submission"],
    .bv-ips-modal-window {
      background: #fff !important;
      border-radius: 16px !important;
      box-sizing: border-box !important;
      color: #231f20 !important;
      font-family: "Arial Rounded MT Bold", sans-serif !important;
      max-height: min(90vh, calc(100dvh - 24px)) !important;
      overflow-x: hidden !important;
      overflow-y: auto !important;
      overscroll-behavior: contain !important;
    }
    [class*="ips_"],
    [class*="ips_"] *:not(svg):not(path):not(stop) {
      color: #231f20 !important;
    }
    [class*="ips_"] h1,
    [class*="ips_"] h2,
    [class*="ips_"] h3,
    [class*="ips_"] h1 *,
    [class*="ips_"] h2 *,
    [class*="ips_"] h3 * {
      font-family: "Arial Rounded MT Bold", sans-serif !important;
      font-weight: 400 !important;
      letter-spacing: 0 !important;
    }
    [class*="ips_"] input:not([type="checkbox"]):not([type="radio"]):not([type="hidden"]),
    [class*="ips_"] textarea {
      background: #fff !important;
      border: 2px solid #231f20 !important;
      border-radius: 6px !important;
      box-sizing: border-box !important;
      color: #231f20 !important;
      font-size: 14px !important;
      padding: 8px 12px !important;
    }
    [class*="ips_"] textarea {
      height: auto !important;
      max-width: none !important;
      min-height: 6.5rem !important;
    }
    [class*="ips_"] input[type="checkbox"],
    [class*="ips_"] input[type="radio"] {
      clip: rect(0, 0, 0, 0) !important;
      height: 1px !important;
      margin: -1px !important;
      opacity: 0 !important;
      overflow: hidden !important;
      padding: 0 !important;
      pointer-events: none !important;
      position: absolute !important;
      width: 1px !important;
    }
    [class*="ips_"] [role="checkbox"] {
      align-items: center !important;
      align-self: center !important;
      background: #fff !important;
      border: 2px solid #231f20 !important;
      border-radius: 3px !important;
      box-sizing: border-box !important;
      cursor: pointer !important;
      display: inline-flex !important;
      flex-shrink: 0 !important;
      height: 18px !important;
      justify-content: center !important;
      margin: 0 8px 0 0 !important;
      min-height: 18px !important;
      min-width: 18px !important;
      opacity: 1 !important;
      padding: 0 !important;
      pointer-events: auto !important;
      position: relative !important;
      visibility: visible !important;
      width: 18px !important;
    }
    [class*="ips_"] [role="checkbox"] svg {
      display: block !important;
      height: 12px !important;
      overflow: visible !important;
      width: 12px !important;
    }
    [class*="ips_"] [role="checkbox"] svg * {
      fill: none !important;
      stroke: #231f20 !important;
      stroke-width: 2 !important;
    }
    [class*="ips_"] [role="checkbox"][aria-checked="false"] svg {
      opacity: 0 !important;
    }
    [class*="ips_"] [role="radiogroup"] {
      align-items: flex-start !important;
      display: flex !important;
      flex-wrap: wrap !important;
      gap: 8px 12px !important;
      justify-content: flex-start !important;
      overflow: visible !important;
      width: 100% !important;
    }
    [class*="ips_"] [role="radiogroup"] > * {
      align-items: center !important;
      display: flex !important;
      flex: 1 1 3.5rem !important;
      flex-direction: column !important;
      justify-content: flex-start !important;
      min-width: 3.5rem !important;
      overflow: visible !important;
      position: relative !important;
      width: auto !important;
    }
    [class*="ips_"] [role="radiogroup"] > * > span,
    [class*="ips_"] [role="radiogroup"] > * > label {
      overflow: visible !important;
      position: static !important;
      text-align: center !important;
      white-space: normal !important;
      width: 100% !important;
    }
    [class*="ips_"] [role="radio"] {
      align-items: center !important;
      background: transparent !important;
      border: 0 !important;
      box-sizing: border-box !important;
      cursor: pointer !important;
      display: inline-flex !important;
      flex: 0 1 auto !important;
      height: auto !important;
      justify-content: center !important;
      margin: 0 !important;
      max-width: none !important;
      min-height: 0 !important;
      min-width: 2.75rem !important;
      opacity: 1 !important;
      overflow: visible !important;
      padding: 4px 8px !important;
      pointer-events: auto !important;
      position: relative !important;
      visibility: visible !important;
      white-space: normal !important;
      width: auto !important;
    }
    [class*="ips_"] [role="radio"]:not([aria-label*="star" i]):not([id^="bv-ips-star"]) {
      background: #fff !important;
      border: 2px solid #231f20 !important;
      border-radius: 6px !important;
      padding: 6px 12px !important;
    }
    [class*="ips_"] [role="radio"][aria-checked="true"]:not([aria-label*="star" i]):not([id^="bv-ips-star"]) {
      background: #fbcf29 !important;
    }
    [class*="ips_"] [role="radio"][id^="bv-ips-star"] {
      background: transparent !important;
      border: 0 !important;
      padding: 4px !important;
    }
    [class*="ips_"] [role="radio"][id^="bv-ips-star"][aria-checked="true"] svg path {
      fill: #fbcf29 !important;
    }
    [class*="ips_"] [role="radio"] svg {
      display: block !important;
      flex-shrink: 0 !important;
      height: auto !important;
      max-height: 40px !important;
      max-width: 40px !important;
      overflow: visible !important;
      width: auto !important;
    }
    [class*="ips_"] [role="radio"]:not([aria-label*="star" i]):not([id^="bv-ips-star"]) svg {
      height: 18px !important;
      width: 18px !important;
    }
    [class*="ips_"] [role="radio"] span,
    [class*="ips_"] [role="radio"] p,
    [class*="ips_"] [role="radio"] label {
      height: auto !important;
      line-height: 1.2 !important;
      overflow: visible !important;
      position: static !important;
      text-overflow: unset !important;
      white-space: normal !important;
      width: auto !important;
    }
    [class*="ips_"] #bv-ips-submit,
    [class*="ips_"] button[id*="submit" i] {
      height: auto !important;
      line-height: 1.2 !important;
      max-width: 100% !important;
      min-height: 42px !important;
      overflow: visible !important;
      text-overflow: unset !important;
      white-space: normal !important;
    }
    [class*="ips_"] #bv-ips-submit span,
    [class*="ips_"] button[id*="submit" i] span {
      overflow: visible !important;
      text-overflow: unset !important;
      white-space: normal !important;
    }
    [class*="ips_"] div:has(> #bv-ips-submit) {
      align-items: stretch !important;
      display: flex !important;
      flex-wrap: wrap !important;
      gap: 8px !important;
      overflow: visible !important;
    }
    [class*="ips_"] [id^="agreement"],
    [class*="ips_"] div:has(> label > [role="checkbox"]),
    [class*="ips_"] label:has(> [role="checkbox"]),
    [class*="ips_"] label:has(> input[type="checkbox"]) {
      align-items: flex-start !important;
      display: flex !important;
      flex-direction: row !important;
      flex-wrap: nowrap !important;
      height: auto !important;
      line-height: 1.35 !important;
      min-height: 18px !important;
    }
    [class*="ips_"] [id^="agreement"] > label,
    [class*="ips_"] label:has(> [role="checkbox"]) {
      align-self: flex-start !important;
      flex-shrink: 0 !important;
      height: 18px !important;
      margin: 2px 8px 0 0 !important;
    }
    [class*="ips_"] [id^="agreement"] > span,
    [class*="ips_"] label:has(> [role="checkbox"]) + span {
      display: inline !important;
      flex: 1 1 auto !important;
      height: auto !important;
      line-height: 1.35 !important;
      margin: 0 !important;
      overflow: visible !important;
      padding: 0 !important;
      white-space: normal !important;
    }
    [class*="ips_"] [id^="agreement"] .bv-text-link,
    [class*="ips_"] [id^="agreement"] [role="button"] {
      color: inherit !important;
      cursor: pointer !important;
      display: inline !important;
      font-size: inherit !important;
      height: auto !important;
      line-height: inherit !important;
      text-decoration: underline !important;
      width: auto !important;
    }
    [class*="ips_"] button[aria-label*="close" i],
    [class*="ips_"] button[title*="close" i] {
      align-items: center !important;
      background: #fff !important;
      border: 2px solid #231f20 !important;
      border-radius: 6px !important;
      box-sizing: border-box !important;
      color: #231f20 !important;
      display: inline-flex !important;
      height: 36px !important;
      justify-content: center !important;
      padding: 6px !important;
      position: absolute !important;
      right: 12px !important;
      top: 12px !important;
      width: 36px !important;
      z-index: 5 !important;
    }
    [class*="ips_"] button[aria-label*="close" i] svg {
      height: 16px !important;
      width: 16px !important;
    }
    [class*="ips_"] button[aria-label*="close" i] svg path {
      fill: #231f20 !important;
      stroke: #231f20 !important;
    }
    [class*="ips_"] button[aria-label*="star" i] svg path {
      fill: #fbcf29 !important;
    }
  `;

  let style = document.getElementById('bf-bv-ips-styles');
  if (!style) {
    style = document.createElement('style');
    style.id = 'bf-bv-ips-styles';
    document.head.appendChild(style);
  }

  if (style.textContent !== css) {
    style.textContent = css;
  }
}

function collectBvRoots() {
  const roots = [document];

  [...document.querySelectorAll('[data-bv-show]'), ...document.body.children].forEach((host) => {
    if (host.shadowRoot) roots.push(host.shadowRoot);
  });

  return roots;
}

function isBvReviewDialog(node) {
  if (!node) return false;
  if (node.id && /review-submission/i.test(node.id)) return true;
  if (node.classList?.contains('bv-ips-modal-window')) return true;
  if (/ips_/.test(String(node.className || ''))) {
    return Boolean(node.matches?.('[role="dialog"]') || node.querySelector?.('textarea, #review-submission, [id*="review-submission"]'));
  }
  if (node.getAttribute?.('role') !== 'dialog') return false;
  return Boolean(node.querySelector?.('[class*="ips_"], #review-submission, [id*="review-submission"], textarea'));
}

function findBvModals() {
  const modals = [];

  collectBvRoots().forEach((root) => {
    root
      .querySelectorAll(
        '#review-submission, [id*="review-submission"], .bv-ips-modal-window, [class*="ips_"][role="dialog"]'
      )
      .forEach((node) => {
        if (isBvReviewDialog(node)) modals.push(node);
      });
  });

  return [...new Set(modals)];
}

function isBvModalOpen(node) {
  if (!node?.isConnected) return false;

  const style = getComputedStyle(node);
  if (style.display === 'none' || style.visibility === 'hidden' || Number(style.opacity) === 0) {
    return false;
  }

  const rect = node.getBoundingClientRect();
  return rect.width > 200 && rect.height > 200;
}

function pickBvModalScroller(modals) {
  const visible = modals.filter(isBvModalOpen);
  if (!visible.length) return null;

  const viewportWidth = window.innerWidth;
  const cards = visible.filter((node) => node.getBoundingClientRect().width < viewportWidth - 40);

  return cards[0] || visible[0];
}

function applyBvModalScroller(dialog) {
  if (!dialog || dialog.dataset.bfBvModalScroll === 'true') return;

  dialog.dataset.bfBvModalScroll = 'true';
  dialog.setAttribute('data-page-smooth-scroll-ignore', '');
  dialog.style.setProperty('max-height', 'min(90vh, calc(100dvh - 24px))', 'important');
  dialog.style.setProperty('overflow-x', 'hidden', 'important');
  dialog.style.setProperty('overflow-y', 'auto', 'important');
  dialog.style.setProperty('overscroll-behavior', 'contain', 'important');
}

function syncBvModalPageLock() {
  const scroller = pickBvModalScroller(findBvModals());
  const open = Boolean(scroller);

  document.documentElement.classList.toggle('bf-bv-modal-open', open);

  if (open) {
    applyBvModalScroller(scroller);
    window.backflipPageSmoothScroll?.pause();
    return;
  }

  window.backflipPageSmoothScroll?.resume();
}

const bvObservedShadows = new WeakSet();

function scheduleBvReviewsChrome() {
  if (bvMutating || bvRestyleScheduled) return;
  bvRestyleScheduled = true;

  requestAnimationFrame(() => {
    bvRestyleScheduled = false;
    if (bvMutating) return;
    bvMutating = true;

    try {
      injectBvReviewsShadow();
    } finally {
      bvMutating = false;
    }
  });
}

function scheduleBvIpsChrome() {
  if (bvIpsScheduled) return;
  bvIpsScheduled = true;

  requestAnimationFrame(() => {
    bvIpsScheduled = false;
    injectBvDocumentIpsStyles();
    injectBvIpsShadows();
    syncBvModalPageLock();
  });
}

function isIpsHost(node) {
  if (!(node instanceof Element)) return false;
  if (node.getAttribute('data-bv-show') === 'inpage_submission') return true;
  if (node.classList.contains('bv-ips-modal-window')) return true;
  if (node.id && /review-submission/i.test(node.id)) return true;
  if (/ips_/i.test(String(node.className || ''))) return true;
  if (!node.shadowRoot) return false;

  return Boolean(node.shadowRoot.querySelector('[class*="ips_"], #review-submission, [id*="review-submission"]'));
}

function attachReviewsObserver(host) {
  if (!host || host.dataset.bfBvObserved === 'true' || typeof MutationObserver === 'undefined') return;
  host.dataset.bfBvObserved = 'true';

  const onChange = (mutations) => {
    bindShadow();
    if (host.shadowRoot) stabilizeBvFilterChrome(host.shadowRoot);
    if (bvMutating) return;

    const onlyExpanded =
      mutations.length > 0 &&
      mutations.every(
        (mutation) => mutation.type === 'attributes' && mutation.attributeName === 'aria-expanded'
      );

    if (onlyExpanded && host.shadowRoot && host.dataset.bfBvChromeDone === 'true') {
      syncBvListboxes(host.shadowRoot);
      return;
    }

    scheduleBvReviewsChrome();
  };

  const observer = new MutationObserver(onChange);
  observer.observe(host, {
    attributes: true,
    attributeFilter: ['data-bv-ready'],
    childList: true,
  });

  const bindShadow = () => {
    if (!host.shadowRoot || bvObservedShadows.has(host.shadowRoot)) return;
    bvObservedShadows.add(host.shadowRoot);
    observer.observe(host.shadowRoot, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['aria-expanded'],
    });
  };

  bindShadow();
  scheduleBvReviewsChrome();
}

function watchReviewsMount() {
  const existing = document.querySelector('[data-bv-show="reviews"]');
  if (existing) {
    attachReviewsObserver(existing);
    return;
  }

  const mount = document.getElementById('product-reviews');
  if (!mount || typeof MutationObserver === 'undefined') return;

  const boot = new MutationObserver(() => {
    const host = document.querySelector('[data-bv-show="reviews"]');
    if (!host) return;
    boot.disconnect();
    attachReviewsObserver(host);
  });

  boot.observe(mount, { childList: true, subtree: true });
}

const bvIpsShadows = new WeakSet();
const bvIpsHostRetries = new WeakSet();

function attachIpsShadowObserver(host) {
  const shadow = host?.shadowRoot;
  if (!shadow || bvIpsShadows.has(shadow)) return;
  const bvShow = host.getAttribute('data-bv-show');
  if (host.tagName === 'SHOP-CART-SYNC' || (bvShow && bvShow !== 'inpage_submission')) return;

  bvIpsShadows.add(shadow);
  console.log('[bf-bv] observe ips host', {
    tag: host.tagName,
    id: host.id,
    cls: String(host.className).slice(0, 80),
    hasIps: Boolean(shadow.querySelector('[class*="ips_"], .bv-ips-modal-window')),
  });

  if (typeof MutationObserver !== 'undefined') {
    const observer = new MutationObserver(() => scheduleBvIpsChrome());
    observer.observe(shadow, { childList: true, subtree: true });
  }

  scheduleBvIpsChrome();
}

function watchPossibleIpsHost(node) {
  if (!(node instanceof Element)) return;
  if (node.shadowRoot) {
    attachIpsShadowObserver(node);
    return;
  }
  if (bvIpsHostRetries.has(node)) return;
  bvIpsHostRetries.add(node);

  let tries = 0;
  const tick = () => {
    if (node.shadowRoot) {
      console.log('[bf-bv] shadow attached later', node.tagName, node.id);
      attachIpsShadowObserver(node);
      return;
    }
    if (++tries < 30) requestAnimationFrame(tick);
  };

  tick();
}

function watchInpageSubmissionHosts() {
  document.querySelectorAll('[data-bv-show="inpage_submission"]').forEach((node) => {
    watchPossibleIpsHost(node);
  });
  [...document.body.children].forEach((node) => watchPossibleIpsHost(node));
}

function observeIpsPortal() {
  if (!document.body || typeof MutationObserver === 'undefined') return;

  watchInpageSubmissionHosts();

  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (!(node instanceof Element)) continue;
        watchPossibleIpsHost(node);
        if (
          isIpsHost(node) ||
          node.querySelector?.('[class*="ips_"], #review-submission, .bv-ips-modal-window')
        ) {
          console.log('[bf-bv] body added ips node', node.tagName, node.id, String(node.className).slice(0, 80));
          scheduleBvIpsChrome();
          return;
        }
      }

      for (const node of mutation.removedNodes) {
        if (isIpsHost(node)) {
          syncBvModalPageLock();
          return;
        }
      }
    }
  });

  observer.observe(document.body, { childList: true });

  document.addEventListener(
    'click',
    (event) => {
      const path = event.composedPath?.() || [];
      const haystack = path
        .filter((node) => node instanceof Element)
        .map((node) => `${node.getAttribute('aria-label') || ''} ${node.textContent || ''}`)
        .join(' ');
      if (!/write (a )?review|review this product|submission form|добавить отзыв/i.test(haystack)) {
        return;
      }
      console.log('[bf-bv] write-review click', (haystack || '').replace(/\s+/g, ' ').slice(0, 120));
      eachOpenShadowHost((node) => watchPossibleIpsHost(node));
      watchInpageSubmissionHosts();
      scheduleBvIpsChrome();
      window.setTimeout(scheduleBvIpsChrome, 150);
      window.setTimeout(scheduleBvIpsChrome, 600);
    },
    true
  );
}

function observeInlineRatings() {
  if (typeof MutationObserver === 'undefined') return;
  if (document.documentElement.dataset.bfBvInlineObserved === 'true') return;
  document.documentElement.dataset.bfBvInlineObserved = 'true';

  const observer = new MutationObserver(() => {
    syncBvReviewDisplay();
  });

  observer.observe(document.body, {
    attributes: true,
    attributeFilter: ['data-bv-ready'],
    childList: true,
    subtree: true,
    characterData: true,
  });
}

function isProductPage() {
  return (
    document.body?.dataset.bfPage === 'product' ||
    Boolean(document.querySelector('[data-bv-show="reviews"], #product-reviews'))
  );
}

function bootBvHelpers() {
  if (document.documentElement.dataset.bfBvBooted === 'true') return;
  document.documentElement.dataset.bfBvBooted = 'true';

  initProductReviewsScroll();
  handlePendingReviewsScroll();
  syncBvReviewDisplay();
  observeInlineRatings();

  const product = isProductPage();
  console.log('[bf-bv] boot', {
    product,
    page: document.body?.dataset.bfPage,
    reviews: Boolean(document.querySelector('[data-bv-show="reviews"], #product-reviews')),
    bodyShadows: [...document.body.children]
      .filter((el) => el.shadowRoot)
      .map((el) => `${el.tagName}#${el.id || ''}`),
  });

  if (!product) return;

  injectBvModalLockStyles();
  injectBvDocumentIpsStyles();
  watchReviewsMount();
  observeIpsPortal();
  scheduleBvIpsChrome();
}

// Smooth scroll for anchor links
document.addEventListener('click', (e) => {
  const anchor = e.target.closest('a[href^="#"]');
  if (!anchor) return;

  const targetId = anchor.getAttribute('href');
  if (targetId === '#') return;

  const isReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (targetId === '#top') {
    e.preventDefault();
    window.scrollTo({
      top: 0,
      behavior: isReduced ? 'auto' : 'smooth',
    });
    return;
  }

  try {
    const targetElement = document.querySelector(targetId);
    if (targetElement) {
      e.preventDefault();
      const scrollToTarget = () => {
        targetElement.scrollIntoView({
          behavior: isReduced ? 'auto' : 'smooth',
          block: 'start',
        });
      };

      scrollToTarget();

      // Pinned ScrollTrigger sections can rebuild mid-scroll (e.g. after lazy images load)
      // and shift the page; re-aim at the target so the first click still lands on it.
      if (window.ScrollTrigger) {
        window.ScrollTrigger.addEventListener('refresh', scrollToTarget);
        setTimeout(() => {
          window.ScrollTrigger.removeEventListener('refresh', scrollToTarget);
        }, 2500);
      }
    }
  } catch (err) {
    // Prevent querySelector errors for invalid selector syntax in href
  }
});

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', bootBvHelpers, { once: true });
} else {
  bootBvHelpers();
}
